////import 'bootstrap';
//var jquery = require("jquery");
//window.$ = window.jQuery = jquery;
//import 'bootstrap/js/dist/util';
//import 'bootstrap/js/dist/dropdown';
//// import 'bootstrap/js/dist/modal';
//import 'bootstrap/dist/css/bootstrap.css';
//import '@fortawesome/fontawesome-svg-core';

import imgLogo from "url:./images/youpret-logo.png";
import imgIconInstant from "url:./images/youpret-icon-instant-200.png";
import imgIconBooking from "url:./images/youpret-icon-booking-200.png";
import imgIconSystem from "url:./images/youpret-icon-system-200.png";
import imgIconOnSite from "url:./images/youpret-icon-onsite-200.png";
import imgIconTranslations from "url:./images/icon-translations.png";
import imgIconFacebook from "url:./images/facebook-64.png";
import imgIconInstagram from "url:./images/instagram-64.png";
import imgIconTwitter from "url:./images/twitter-64.png";
import imgIconLinkedIn from "url:./images/linkedin-64.png";
import imgIconYoutube from "url:./images/icon-youtube.svg";
import imgIconTiktok from "url:./images/icon-tiktok.png";
import imgIconTiktokSecondary from "url:./images/icon-tiktok.png";
import imgIconYoutubeSecondary from "url:./images/icon-youtube.svg";
import imgIconFacebookSecondary from "url:./images/facebook-64.png";
import imgIconInstagramSecondary from "url:./images/instagram-64.png";
import imgIconTwitterSecondary from "url:./images/twitter-64.png";
import imgIconLinkedInSecondary from "url:./images/linkedin-64.png";
import imgIconFacebookAnother from "url:./images/facebook-64.png";
import imgIconInstagramAnother from "url:./images/instagram-64.png";
import imgIconTwitterAnother from "url:./images/twitter-64.png";
import imgIconLinkedInAnother from "url:./images/linkedin-64.png";
import imgIconEriarvoisuus from "url:./images/icon-eriarvoisuus.png";
import imgIconTyoJaTalouskasvu from "url:./images/icon-tyo-ja-talouskasvu.png";
import imgIconTeollisuusJaInfra from "url:./images/icon-teollisuus-ja-infra.png";
import imgIconKoulutus from "url:./images/icon-koulutus.png";
import imgIconDecentWork from "url:./images/icon-decent-work.png";
import imgIconIndustryInnovation from "url:./images/icon-industry-innovation.png";
import imgIconReducedInequalities from "url:./images/icon-reduced-inequalities.png";
import imgIconQualityEducation from "url:./images/icon-quality-education.png";
import imgIconGodUtbildningForAlla from "url:./images/icon-god-utbildning-for-alla.png";
import imgIconAnstandigaArbetsvillkorOchEkonomiskTillvaxt from "url:./images/icon-anstandiga-arbetsvillkor-och-ekonomisk-tillvaxt.png";
import imgIconHallbarIndustriInnovationerOchInfrastruktur from "url:./images/icon-hallbar-industri-innovationer-och-infrastruktur.png";
import imgIconMinskadOjamnlikhet from "url:./images/icon-minskad-ojamnlikhet.png";
import imgIconOrderTranslation from "url:./images/icon-order-translation.png";

import imgNewsIconIndustryAndInfrastructure from "url:./images/news-icon-industry-and-infrastructure.png";
import imgNewsIconReducedInequalities from "url:./images/news-icon-reduced-inequalities.png";
import imgNewsIconDecentWorkAndEconomicGrowth from "url:./images/news-icon-decent-work-and-economic-growth.png";
import imgNewsIconDecentWorkAndEconomicGrowth1 from "url:./images/news-icon-decent-work-and-economic-growth.png";
import imgNewsIconEriarvoisuus from "url:./images/news-icon-eriarvoisuus.jpg";
import imgNewsIconTeollisuusJaInfra from "url:./images/news-icon-teollisuus-ja-infra.jpg";
import imgNewsIconTyoJaTalouskasvu from "url:./images/news-icon-tyo-ja-talouskasvu.jpg";
import imgNewsIconTyoJaTalouskasvu1 from "url:./images/news-icon-tyo-ja-talouskasvu.jpg";


import imgHomeMain from "url:./images/youpret-main-1500x1000.jpg";
import imgYoupretHand from "url:./images/youpret-hand-1200x800.jpg";
import imgPremiumHandshake from "url:./images/youpret-premium-handshake-1200x800.jpg";
import imgGooglePlayBadge from "url:./images/google-play-badge.png";
import imgGooglePlayBadge2 from "url:./images/google-play-badge.png";
import imgGooglePlayBadgeSv from "url:./images/google-play-badge-sv.png";
import imgAppleBadgeFi from "url:./images/apple-badge-fi.png";
import imgAppleBadgeFi2 from "url:./images/apple-badge-fi.png";
import imgAvainlippu from "url:./images/avainlippu-youpret-103x100.png";
import imgAvainlippuSecondary from "url:./images/avainlippu-youpret-103x100.png";
import imgAvainlippuMobile from "url:./images/avainlippu-youpret-103x100.png";

import imgDonation from "url:./images/youpret-donation-1200x630.jpg";
import imgToWho from "url:./images/youpret-main-2-1500x1000.jpg";
import imgVismaLogo from "url:./images/Visma_logo-134x25.png"

import imgNewsViisiVinkkiaKotonaTulkkaaville from "url:./images/interpretation-five-tips-1200x630.jpg";
import imgNewsViisiVinkkiaKotonaTulkkaavilleSmall from "url:./images/interpretation-five-tips-600x315.jpg";
import imgNewsYoupretLahjoittaa from "url:./images/youpret-donation-1200x630.jpg";
import imgNewsYoupretLahjoittaaSmall from "url:./images/youpret-donation-600x315.jpg";
import imgNewsKorona from "url:./images/korona-1200x630.jpg";
import imgNewsKoronaSmall from "url:./images/korona-600x315.jpg";
import imgNewsVinkit from "url:./images/remote-tips-1200x630-og.png";
import imgNewsVinkitSmall from "url:./images/remote-tips-600x315.jpg";
import imgNewsVinkit1 from "url:./images/remote-tip-1.png";
import imgNewsVinkit2 from "url:./images/remote-tip-2.png";
import imgNewsVinkit3 from "url:./images/remote-tip-3.png";
import imgNewsVinkit4 from "url:./images/remote-tip-4.png";
import imgNewsVinkit5 from "url:./images/remote-tip-5.png";
import imgNewsVinkit6 from "url:./images/remote-tip-6.png";
import imgNewsMitenTukea from "url:./images/miten-tukea-oppilasta-1200x630.jpg";

import imgNewsMitenTukeaSmall from "url:./images/miten-tukea-oppilasta-600x315.jpg";
import imgNewsMitenTukeaSuvi from "url:./images/miten-tukea-suvi-600.jpg";
import imgNewsRareLanguages from "url:./images/rare-languages-1200x630.png";
import imgNewsRareLanguagesSmall from "url:./images/rare-languages-600x315.png";
import imgNewsAfrikaBanner from "url:./images/afrikka-postaus-1200x630.jpg";
import imgNewsAfrikaBannerSmall from "url:./images/afrikka-postaus-630x315.png";
import imgNewsAfricaBannerEng from "url:./images/news-africa-banner-1200x630-eng.png";
import imgNewsAfricaBannerSmallEng from "url:./images/news-africa-banner-630x315-eng.png";
import imgNewsAfricaMapEng from "url:./images/news-africa-map-eng.png";
import imgNewsInterpretersRecommend from "url:./images/tulkit-suosittelevat-youpret-1200x630.jpg";
import imgNewsInterpretersRecommendSmall from "url:./images/tulkit-suosittelevat-youpret-630x315.jpg";
import imgCustomReferenceEksote from "url:./images/interpreter-customer-reference-eksote-1200x630.jpg";
import imgCustomReferenceEksoteSmall from "url:./images/interpreter-customer-reference-eksote-600x315.jpg";
import imgCustomReferenceRauma from "url:./images/interpreter-customer-reference-rauma-1200x630.jpg";
import imgCustomReferenceRaumaSmall from "url:./images/interpreter-customer-reference-rauma-600x315.jpg";
import imgRecruitment from "url:./images/interpreter-recruitment-1200x630.jpg";
import imgRecruitmentSmall from "url:./images/interpreter-recruitment-600x315.jpg";
import imgSuosikkitulkki from "url:./images/favorite-interpreter-1200x630.jpg";
import imgSuosikkitulkkiSmall from "url:./images/favorite-interpreter-600x315.jpg";
import imgDragonsDenAfter from "url:./images/dragons-den-after-1200x630.jpg";
import imgDragonDenAfterSmall from "url:./images/dragons-den-after-600x315.jpg";
import imgCoordinator from "url:./images/interpreter-coordinator-1200x630.jpg";
import imgCoordinatorSmall from "url:./images/interpreter-coordinator-600x315.jpg";
import imgJaniKamarainen from "url:./images/jani-kamarainen-youpret.jpg";
import imgTulkkitapaaminenYhteiskuva from "url:./images/tulkkitapaaminen-yhteiskuva-1200x630.jpg";
import imgTulkkitapaaminenYhteiskuvaSmall from "url:./images/tulkkitapaaminen-yhteiskuva-600x315.jpg";
import imgArabic from "url:./images/arabic-1200x630.png";
import imgArabicSmall from "url:./images/arabic-600x315.png";
import imgYoupretInterpreter from "url:./images/youpret-interpreter.jpg";
import imgLeijonanLuola from "url:./images/ll-1200x630.png";
import imgLeijonanLuolaSmall from "url:./images/ll-600x315.png";
import imgWhyYoupret from "url:./images/why-youpret-1200x630.jpg";
import imgWhyYoupretSmall from "url:./images/why-youpret-600x315.jpg";
import imgWhyYoupretNopea from "url:./images/why-youpret-nopea-1200x800.jpg";
import imgCustomerView from "url:./images/youpret-customer-view-fi.png";
import imgFaq from "url:./images/faq-1200x630.jpg";
import imgFaqSmall from "url:./images/faq-600x315.jpg";
import imgNewsYear2023kielet from "url:./images/news-year-2023-kielet.png";
import imgNewsYear2023tiistain from "url:./images/news-year-2023-tiistai.png";
import imgNewsYear2023lyhyin from "url:./images/news-year-2023-lyhyin.png";
import imgNewsYear2023tyytyvaisyys from "url:./images/news-year-2023-tyytyvaisyys.png";
import imgNewsYear2023yli from "url:./images/news-year-2023-yli.png";
import imgNewsTulkinTyo2020Luvulla from "url:./images/news-tulkin-tyo2020-luvulla1200x630.jpg";
import imgNewsTulkinTyo2020LuvullaSmall from "url:./images/news-tulkin-tyo2020-luvulla630x315.jpg";
import imgNewsTulkinTyo2020LuvullaEng from "url:./images/news-tulkin-tyo2020-luvulla1200x630.jpg";
import imgNewsTulkinTyo2020LuvullaSmallEng from "url:./images/news-tulkin-tyo2020-luvulla630x315.jpg";
import imgNewsAllAboutSustainabilityOurOperationsEng from "url:./images/news-all-about-sustainability-our-operations-eng.png";
import imgNewsAllAboutSustainabilityEng from "url:./images/news-all-about-sustainability-eng1200x630.jpg";
import imgNewsAllAboutSustainabilityEngSmall from "url:./images/news-all-about-sustainability-eng630x315.jpg";
import imgNewsAllAboutSustainabilityIs from "url:./images/news-all-about-sustainability-eng1200x630.jpg";
import imgNewsAllAboutSustainabilityIsSmall from "url:./images/news-all-about-sustainability-eng630x315.jpg";
import imgNewsKaikkiVastuullisuusRaportoinnista from "url:./images/news-kaikki-vastuullisuus-raportoinnista1200x630.jpg";
import imgNewsKaikkiVastuullisuusRaportoinnistaSmall from "url:./images/news-kaikki-vastuullisuus-raportoinnista630x315.jpg";
import imgNewsToimintamme from "url:./images/news-toimintamme.png";
import imgNewsIconHyvaKoulutus from "url:./images/news-icon-hyva-koulutus.png";
import imgNewsItaUudenmaaSmall from "url:./images/ita-uudenmaa-630x315.jpg";
import imgNewsItaUudenmaa from "url:./images/ita-uudenmaa-1200x630.jpg";


import imgAjanvarausKuva from "url:./images/ajanvarausKuva.png"
import imgAjanvarausKuvaSv from "url:./images/ajanvarausKuvaSv.png"
import kayttoohjeKuva from "url:./images/kayttoohjeKuva.png"
import imgEtatulkkausKuva from "url:./images/etatulkkausKuva.png"
import imgEtatulkkausKuvaSv from "url:./images/etatulkkausKuvaSv.png"
import imgSoitaKuva from "url:./images/soitaKuva.png"
import imgSoitaKuvaSv from "url:./images/soitaKuvaSv.png"
import imgLataaSovellus from "url:./images/Lataa-sovellus-uusikuva.jpg"
import imgLataaSovellusSv from "url:./images/Lataa-sovellusSv.png"
import imgLoppuKuva from "url:./images/loppuKuva.png"
import imgLoppuKuvaSv from "url:./images/loppuKuvaSv.png"
import imgMenuKuva from "url:./images/menuKuva.png"
import imgMenuKuvaSv from "url:./images/menuKuvaSv.png"
import imgViiteKuva from "url:./images/viiteKuva.png"
import imgViiteKuvaSv from "url:./images/viiteKuvaSv.png"
import nuoliYlos from "url:./images/up-arrow.svg" 
import imgServices from "url:./images/services-2000x600.jpg";
import imgSchools from "url:./images/school-people-1200x630.jpg";
import imgYoupretVismaVideo from "url:./images/youpret-and-visma-play-video-1280x720.jpg";
import imgUudetNettisivut2020 from "url:./images/uudet-nettisivut-2020.jpg";
import imgUudetNettisivut2020Kirjaudu from "url:./images/uudet-nettisivut-2020-kirjaudu.png";
import imgAbrialBertelYoupret from "url:./images/abrial-bertel-youpret-120.jpg";
import imgRekrykoulutusKieliteknologiaSmall from "url:./images/Rekryilmoitus-kieliteknologia630x315.png";
import imgRekrykoulutusKieliteknologia from "url:./images/Rekryilmoitus-kieliteknologia1200x630.jpg";
import svgStar from "url:./images/star.svg";
import svgRightArrow from "url:./images/right-arrow.svg";
import imgNeaKolmonenYoupret from "url:./images/nea-kolmonen-youpret.png";
import imgNeaKolmonenYoupret1 from "url:./images/nea-kolmonen-youpret-1.png";
import imgResponsibilityOpenBook from "url:./images/book-open.png";
import imgJaniKamarainenYoupret from "url:./images/jani-kamarainen-youpret-120.png";
import imgMayaRytkonenYoupret from "url:./images/maya-rytkonen-youpret-120x180.png";
import imgNeaRuotsalainenYoupret from "url:./images/nea-ruotsalainen-youpret-120x180.png";
import imgLauraKosonenYoupret from "url:./images/laura-kosonen-youpret-120x180.png";
import imgSuviKingelinYoupret from "url:./images/suvi-kingelin-youpret-120x180.png";
import imgSatuPirhonenYoupret from "url:./images/satu-pirhonen-youpret.png";
import imgNeaKolmonenContactYoupret from "url:./images/nea-kolmonen-contact-youpret.png";
import imgTanjaYoupret from "url:./images/tanja-youpret.png";
import imgHeikkiVepsalainenYoupret from "url:./images/heikki-vepsalainen-youpret-120x180.png";
import imgManualInstantInterpreter from "url:./images/pikatulkki-aloitus.png";
import imgManualWaitForInterpreter from "url:./images/olevalmiina-kuva.png";
import imgManualOnlineBooking from "url:./images/ajanvaraus-aloitus.png";
import imgManualReviewInstantInterpretation from "url:./images/pikatulkkaus-arviointi.png";
import imgManualReviewOnlineInterpretation from "url:./images/ajanvaraus-arvioi-tulkkaus.png";
import imgManualAddNoteInstantInterpretation from "url:./images/viitteen-lisaaminen-pikatulkki.png";
import imgManualAddNoteOnlineInterpretation from "url:./images/viitteen-lisaaminen-ajanvaraus.png";
import imgManualAddNoteOnlineAfter from "url:./images/viite-lisays-jalkeen.png";
import imgYritysVastuu from "url:./images/yritysvastuu1200x630.jpg";
import imgYritysVastuu_small from "url:./images/yritysvastuu600x315.jpg";
import imgAvoimetTyopaikat from "url:./images/tyoharjoittelu.jpg";
import imgNewsToissaYoupretillaBanner from "url:./images/toissayoupretilla1200x630.jpg";
import imgNewsToissaYoupretillaBannerSmall from "url:./images/toissayoupretilla600x315.png";
import imgNewsMaya from "url:./images/toissa-youpretilla-maya.jpg";
import imgNewsNea from "url:./images/toissa-youpretilla-nea.jpg";
import imgNewsLaura from "url:./images/toissa-youpretilla-laura.jpg";
import drivingSchoolBanner from "url:./images/driving-school-banner-1200x630.png";
import drivingSchoolBannerSmall from "url:./images/driving-school-banner-600x315.png";
import drivingSchoolBanner2 from "url:./images/driving-school-banner2-1200x630.jpg";
import legalBanner from "url:./images/legal-banner-1200x630.png";
import legalBanner2 from "url:./images/legal-banner2-1200x639.jpg";
import legalNewsBanner from "url:./images/legal-banner-1200x630.png";
import legalNewsBannerSmall from "url:./images/legal-banner-600x315.png";
import imgNewsJobAssistant from "url:./images/taloushallinnonassistentti1200x630.jpg";
import imgNewsJobAssistantSmall from "url:./images/taloushallinnonassistentti600x315.png";
import imgNewsDrivingSchoolBanner from "url:./images/autokoulutulkki1200x630.png";
import imgNewsDrivingSchoolBannerSmall from "url:./images/autokoulutulkki600x315.png";
import imgChildhoodEducationBanner from "url:./images/varhaiskasvatus-markkinointi-banner1200x630.png";
import imgChildhoodEducationBannerSmall from "url:./images/varhaiskasvatus-markkinointi-banner600x315.png";
import imgChildhoodEducationBanner2 from "url:./images/varhaiskasvatus-markkinointi1200x630.jpg";
import imgChildhoodEducationBanner2Small from "url:./images/varhaiskasvatus-markkinointi600x315.png";
import imgNewsKindergarten from "url:./images/varhaiskasvatus1200x630.jpg";
import imgNewsKindergartenSmall from "url:./images/varhaiskasvatus600x315.png";
import imgNewsAlustatalousBanner from "url:./images/alustatalous-1200x630.jpg";
import imgNewsAlustatalousBannerSmall from "url:./images/alustatalous-630x315.png";
import imgNewsAfrikaMap from "url:./images/afrikan-kartta.jpg";
import imgHealthInterpreterBanner from "url:./images/terveystulkki1200x630.png";
import imgHealthInterpreterBannerSmall from "url:./images/terveystulkki630x315.png";
import imgHealthInterpreter2Banner from "url:./images/terveystulkki2-1200x630.jpg";
import imgHealthInterpreter2BannerSmall from "url:./images/terveystulkki2-630x315.png";
import imgNewsMiroTeravainenBanner from "url:./images/miroteravainen-blogi1200x615.jpg";
import imgNewsMiroTeravainenBannerSmall from "url:./images/miroteravainen-blogi630x315.png";
import imgNewsMiroTeravainen from "url:./images/miroteravainen-blogi-kuva.jpg";
import imgNewsDawdaBannerSmall from "url:./images/dawda-badjie-banner-630x315.png";
import imgNewsDawdaBanner from "url:./images/dawda-badjie-banner-1200x630.jpg";
import imgNewsDawdaImage1 from "url:./images/dawda-badjie-img1.jpg";
import imgNewsDawdaImage2 from "url:./images/dawda-badjie-img2.jpg";
import imgNewsDawdaImage3 from "url:./images/dawda-badjie-img3.jpg";
import imgNewsJobSalesAssistant from "url:./images/tulkkauspalveluiden-myyja-1200x630.jpg";
import imgNewsJobSalesAssistantSmall from "url:./images/tulkkauspalveluiden-myyja-630x315.png";
import imgNewsJobCustomerServant from "url:./images/asiakaspalvelijantyo1200x630.jpg";
import imgNewsJobCustomerServantSmall from "url:./images/asiakasneuvojantyo630x315.png";
import imgNewsJobCustomerAdvisor from "url:./images/asiakasneuvojantyo1200x630.jpg";
import imgNewsJobCustomerAdvisorSmall from "url:./images/asiakaspalvelijantyo630x315.png";
import imgNewsRecruitmentTraining from "url:./images/rekrykoulutus1200x800.jpg";
import imgNewsRecruitmentTrainingSmall from "url:./images/rekrykoulutus600x315.jpg";
import imgNewsNewApp from "url:./images/img_news_youpretin_uusi_mobiilisovellus.png";
import imgNewsNewAppSmall from "url:./images/img_news_youpretin_uusi_mobiilisovellus_small.png";
import imgNewsSarastiaYoupret from "url:./images/sarastia-youpret-1200x630.png";
import imgNewsSarastiaYoupretSmall from "url:./images/sarastia-youpret-630x315.png";
import imgNewsTips from "url:./images/news-tips1200x630.jpg";
import imgNewsTipsSmall from "url:./images/news-tips630x315.png";
import imgNewsAccounting from "url:./images/laskutus-1200x630.jpg";
import imgNewsAccountingSmall from "url:./images/laskutus-630x315.jpg";
import imgNewsKieliEttan from "url:./images/kieliettan-1200x630.jpg";
import imgNewsKieliEttanSmall from "url:./images/kieliettan-630x315.jpg";
import imgNewsTaisto from "url:./images/taisto-1200x630.jpg";
import imgNewsTaistoSmall from "url:./images/taisto-630x315.jpg";
import imgNewsAcademy from "url:./images/youpret-academy-blog1200x630.jpg";
import imgNewsAcademySmall from "url:./images/youpret-academy-blog630x315.jpg";
import imgNewsSatisfiedInterpreters2 from "url:./images/tulkeista-on-tyytyvaisia-youpretin-palveluihin.png";
import imgNewsSatisfiedInterpreters1 from "url:./images/nps-luku.png";
import imgNewsSatisfiedInterpreters3 from "url:./images/on-tyytyvaisia-sovellukseen.png";
import imgNewsSatisfiedInterpreters4 from "url:./images/on-tyytyaisia-asiakaspalveluun.png";
import imgNewsSatisfiedInterpreters5 from "url:./images/tulkeista-tyytyvaisia-etta-heidan-ammattitai-taan-arvostetaan.png";
import imgNewsSatisfiedInterpreters6 from "url:./images/tulkeista-tyytyvaisia-yhtenvertaiseen-kohteluun.png";
import imgNewsSatisfiedInterpreters2Ru from "url:./images/news-satisfied-interpreters-2-ru.png";
import imgNewsSatisfiedInterpreters1Ru from "url:./images/news-satisfied-interpreters-1-ru.png";
import imgNewsSatisfiedInterpreters3Ru from "url:./images/news-satisfied-interpreters-3-ru.png";
import imgNewsSatisfiedInterpreters4Ru from "url:./images/news-satisfied-interpreters-4-ru.png";
import imgNewsSatisfiedInterpreters5Ru from "url:./images/news-satisfied-interpreters-5-ru.png";
import imgNewsSatisfiedInterpreters6Ru from "url:./images/news-satisfied-interpreters-6-ru.png";
import imgNewsTulkkienKoulutus from "url:./images/tulkkien-koulutus1200x630.jpg";
import imgNewsTulkkienKoulutusSmall from "url:./images/tulkkien-koulutus630x315.jpg";
import imgNewsPalauteParantaa from "url:./images/news-palaute-parantaa1200x630.jpg";
import imgNewsPalauteParantaaSmall from "url:./images/news-palaute-parantaa630x315.jpg";
import imgNewsPalauteParantaaMeta from "url:./images/news-palaute-parantaa1200x630.jpg";
import imgNewsSurvey from "url:./images/youpret-interpreter-survey1200x630.png";
import imgNewsSurveySmall from "url:./images/youpret-interpreter-survey630x315.png";
import imgNewsSurveyRu from "url:./images/news-youpret-interpreter-survey-ru1200x630.png";
import imgNewsSurveySmallRu from "url:./images/news-youpret-interpreter-survey-ru630x315.png";
import imgNewsVuosi2023Small from "url:./images/youpret-vuosi-2023-630x315.png";
import imgNewsVuosi2023 from "url:./images/youpret-vuosi-2023-1200x630.png";
import imgNewsYoupretSuomenYrittajienKumppaniksiSmall from "url:./images/news-youpret-suomen-yrittajien-kumppaniksi630x315.jpg";
import imgNewsYoupretSuomenYrittajienKumppaniksi from "url:./images/news-youpret-suomen-yrittajien-kumppaniksi1200x630.jpg";
import imgNewsUusiAcademyKurssiSmall from "url:./images/news-uusi-academy-kurssi630x315.jpg";
import imgNewsUusiAcademyKurssi from "url:./images/news-uusi-academy-kurssi1200x630.jpg";
import imgNewsWorkWellbeingBlogpostSmall from "url:./images/news-work-wellbeing-blogpost630x315.jpg";
import imgNewsWorkWellbeingBlogpost from "url:./images/news-work-wellbeing-blogpost1200x630.jpg";
import imgNewsWorkWellbeingCoffee from "url:./images/news-work-wellbeing-coffee.png";
import imgNewsWorkWellbeingCoffee2 from "url:./images/news-work-wellbeing-coffee.png";
import imgNewsWorkWellbeingExercices from "url:./images/news-work-wellbeing-exercices.png";
import imgNewsWorkWellbeingExercices2 from "url:./images/news-work-wellbeing-exercices.png";
import imgNewsWorkWellbeingTalk from "url:./images/news-work-wellbeing-talk.png";
import imgNewsWorkWellbeingTalk2 from "url:./images/news-work-wellbeing-talk.png";
import imgNewsKayttoonottokoulutus from "url:./images/news-kayttoonottokoulutus1200x630.jpg";
import imgNewsKayttoonottokoulutusSmall from "url:./images/news-kayttoonottokoulutus630x315.jpg";
import imgNewsNpsNumber from "url:./images/news-nps-number.png";
import imgNewsNpsLuku from "url:./images/news-nps-luku.png";
import imgNewsNpsSv from "url:./images/news-nps-sv.png";
import imgNewsArtboard1 from "url:./images/news-artboard-1.png";
import imgNewsArtboard1Secondary from "url:./images/news-artboard-1.png";
import imgNewsArtboard2 from "url:./images/news-artboard-2.png"; 
import imgNewsArtboard2Secondary from "url:./images/news-artboard-2.png";
import imgNewsArtboard57 from "url:./images/news-artboard-57.png";
import imgNewsArtboard57Secondary from "url:./images/news-artboard-57.png";
import imgNewsCustomerSatisfactionSmall from "url:./images/news-customer-satisfaction630x315.png";
import imgNewsCustomerSatisfaction from "url:./images/news-customer-satisfaction1200x630.png";
import imgNewsCustomerSatisfactionSecondary from "url:./images/news-customer-satisfaction1200x630.png";
import imgNewsInfographicEn from "url:./images/news-infographic.png";
import imgNewsInfograafi from "url:./images/news-infograafi.png";
import imgNewsInfograafiRu from "url:./images/news-infograafi-ru.png";
import imgNewsCollage from "url:./images/news-collage.jpg";
import imgNewsYoupretBCorpSmall from "url:./images/news-youpret-b-corp630x315.png";
import imgNewsYoupretBCorp from "url:./images/news-youpret-b-corp1200x630.png";
import imgNewsYoupretWorkenvironment from "url:./images/youpret-workenvironment.jpg";
import imgNewsPlant from "url:./images/news-plant.jpg";
import imgNewsLecture from "url:./images/news-lecture.jpg";
import imgNewsRekrykoulutusSmall from "url:./images/news-rekrykoulutus630x315.jpg";
import imgNewsRekrykoulutus from "url:./images/news-rekrykoulutus1200x630.jpg";
import imgNewsKuntapaattajatSmall from "url:./images/news-kuntapaattajat630x315.jpg";
import imgNewsKuntapaattajat from "url:./images/news-kuntapaattajat1200x630.jpg";
import imgNewsKuntapaattajatTerveydenhoito from "url:./images/news-kuntapaattajat-terveydenhoito.png";
import imgNewsEnhancingInterpretationQuality from "url:./images/news-enhancing-interpretation-quality.jpg";
import imgNewsEnhancingInterpretationQualitySmall from "url:./images/news-enhancing-interpretation-quality-small.jpg";
import imgNewsEnhancingInterpretationEssay from "url:./images/news-enhancing-interpretation-essay.jpg";
import imgNewsEnhancingInterpretationMobile from "url:./images/news-enhancing-interpretation-mobile.png";
import imgNewsEnhancingInterpretationTranslator from "url:./images/news-enhancing-interpretation-translator.jpg";
import imgNewsEnhancingInterpretationVideoConference from "url:./images/news-enhancing-interpretation-video-conference.jpg";
import imgNewsNainYrityksetRakentavatLuottamustaSmall from "url:./images/news-nain-yritykset-rakentavat-luottamusta630x315.jpg";
import imgNewsNainYrityksetRakentavatLuottamusta from "url:./images/news-nain-yritykset-rakentavat-luottamusta1200x630.jpg";
import imgNewsTulkkausolosuhteidenVaikutusTulkkauksenOnnistumiseenSmall from "url:./images/news-tulkkausolosuhteiden-vaikutus-tulkkauksen-onnistumiseen630x315.jpg";
import imgNewsTulkkausolosuhteidenVaikutusTulkkauksenOnnistumiseen from "url:./images/news-tulkkausolosuhteiden-vaikutus-tulkkauksen-onnistumiseen1200x630.jpg";
import imgNewsAcademyKehittaaTulkkaustaitoja from "url:./images/news-academy-kehittaa-tulkkaustaitoja1200x630.png";
import imgNewsAcademyKehittaaTulkkaustaitojaSmall from "url:./images/news-academy-kehittaa-tulkkaustaitoja630x315.png";
import imgNewsSiunSoteJaPk from "url:./images/news-siun-sote1200x630.png";
import imgNewsSiunSoteJaPkSmall from "url:./images/news-siun-sote630x315.png";
import imgNewsTePalvelut from "url:./images/news-te-palvelut1200x630.png";
import imgNewsTePalvelutSmall from "url:./images/news-te-palvelut630x315.png";
import imgNewsVarsinaisSuomenTePalvelutSmall from "url:./images/news-varsinais-suomen-te-palvelut630x315.png";
import imgNewsVarsinaisSuomenTePalvelut from "url:./images/news-varsinais-suomen-te-palvelut1200x630.png";
import imgNewsUusimaaTeServices from "url:./images/news-uusimaa-te-services1200x630.png";
import imgNewsUusimaaTeServicesSmall from "url:./images/news-uusimaa-te-services630x315.png";
import imgNewsSouthwestFinlandTeServices from "url:./images/news-southwest-finland-te-services1200x630.png";
import imgNewsSouthwestFinlandTeServicesSmall from "url:./images/news-southwest-finland-te-services630x315.png";
import imgNewsSyksynTapahtumatSmall from "url:./images/news-syksyn-tapahtumat630x315.png";
import imgNewsSyksynTapahtumat from "url:./images/news-syksyn-tapahtumat1200x630.png";
import imgNewsAsiakaspalveluAsiakkaidenSmall from "url:./images/news-asiakaspalvelu-asiakkaiden630x315.png";
import imgNewsAsiakaspalveluAsiakkaiden from "url:./images/news-asiakaspalvelu-asiakkaiden1200x630.png";
import imgNewsTiedotePostausKelaSmall from "url:./images/news-tiedote-postaus-kela630x315.png";
import imgNewsTiedotePostausKela from "url:./images/news-tiedote-postaus-kela1200x630.png";
import imgNewsNurseDays from "url:./images/news-nurse-days1200x630.jpg";
import imgNewsNurseDaysSmall from "url:./images/news-nurse-days630x315.jpg";
import imgNewsNurseDaysSv from "url:./images/news-nurse-days1200x630.jpg";
import imgNewsNurseDaysSvSmall from "url:./images/news-nurse-days630x315.jpg";
import imgNewsKuinkaValitaSmall from "url:./images/news-kuinka-valita630x315.jpg";
import imgNewsKuinkaValita from "url:./images/news-kuinka-valita1200x630.jpg";
import imgNewsInterpretersSatisfactionSurvey from "url:./images/news-interpreters-satisfaction-survey-1200x630.jpg";
import imgNewsInterpretersSatisfactionSurveyFi from "url:./images/news-interpreters-satisfaction-survey-1200x630.jpg";
import imgNewsInterpretersSatisfactionSurveySmall from "url:./images/news-interpreters-satisfaction-survey-630x315.jpg";
import imgNewsInterpretersSatisfactionSurveyIs from "url:./images/news-interpreters-satisfaction-survey-1200x630.jpg";
import imgNewsInterpretersSatisfactionSurveySmallIs from "url:./images/news-interpreters-satisfaction-survey-630x315.jpg";
import imgNewsInterpretersSatisfactionSurveySmallFi from "url:./images/news-interpreters-satisfaction-survey-630x315.jpg";
import imgNewsInterpretersSatisfactionSurveyPodcast from "url:./images/news-interpreters-satisfaction-survey-podcast.jpg";
import imgNewsInterpretersSatisfactionSurveyPodcastFi from "url:./images/news-interpreters-satisfaction-survey-podcast.jpg";
import imgNewsInterpretersSatisfactionSurveyNPS from "url:./images/news-interpreters-satisfaction-survey-NPS.png";
import imgNewsInterpretersSatisfactionSurveyNPSEng from "url:./images/news-interpreters-satisfaction-survey-NPS-eng.png";
import imgNewsYoupretDeloitte from "url:./images/youpret-deloitte1200x630.jpg";
import imgNewsYoupretDeloitteSmall from "url:./images/youpret-deloitte630x315.jpg";
import imgNewsAsiakastarinatKuopioKotokunta from "url:./images/news-asiakastarinat-kuopio-kotokunta1200x630.jpg";
import imgNewsAsiakastarinatKuopioKotokuntaSmall from "url:./images/news-asiakastarinat-kuopio-kotokunta630x315.jpg";
import imgNewsRekrykoulutus2024Small from "url:./images/news-rekrykoulutus-2024-630x315.png";
import imgNewsRekrykoulutus2024 from "url:./images/news-rekrykoulutus-2024-1200x630.png";
import imgNewsTekoalynVastuullinenKaytto from "url:./images/news-tekoalyn-vastuullinen-kaytto1200x630.jpg";
import imgNewsTekoalynVastuullinenKayttoSmall from "url:./images/news-tekoalyn-vastuullinen-kaytto630x315.jpg";
import imgNewsTekoalynVastuullinenKayttoEng from "url:./images/news-tekoalyn-vastuullinen-kaytto1200x630.jpg";
import imgNewsTekoalynVastuullinenKayttoSmallEng from "url:./images/news-tekoalyn-vastuullinen-kaytto630x315.jpg";
import imgNewsKototekopalkinto from "url:./images/news-kototekopalkinto1200x630.jpg";
import imgNewsKototekopalkintoSmall from "url:./images/news-kototekopalkinto630x315.jpg";
import imgNewsVastaanottokeskusKeskiSuomiSmall from "url:./images/news-vastaanottokeskus-keski-suomi630x315.jpg";
import imgNewsVastaanottokeskusKeskiSuomi from "url:./images/news-vastaanottokeskus-keski-suomi1200x630.jpg";
import imgNewsTulkkauspalveluidenHyodyntaminen from "url:./images/news-tulkkauspalveluiden-hyodyntaminen1200x630.jpg";
import imgNewsTulkkauspalveluidenHyodyntaminenSmall from "url:./images/news-tulkkauspalveluiden-hyodyntaminen630x315.jpg";
import imgNewsYoupretiltaRatkaisut from "url:./images/news-youpretilta-ratkaisut1200x630.jpg";
import imgNewsYoupretiltaRatkaisutSmall from "url:./images/news-youpretilta-ratkaisut630x315.jpg";
import imgNewsKuntamarkkinat from "url:./images/news-kuntamarkkinat1200x630.jpg";
import imgNewsKuntamarkkinatSmall from "url:./images/news-kuntamarkkinat630x315.jpg";
import imgNewsReceptionCenterEng from "url:./images/news-reception-center-eng1200x630.png";
import imgNewsReceptionCenterEngSmall from "url:./images/news-reception-center-eng630x315.jpg";
import imgNewsIhminenVastuussaTekoalystaSmall from "url:./images/news-ihminen-vastuussa-tekoalysta630x315.jpg";
import imgNewsIhminenVastuussaTekoalysta from "url:./images/news-ihminen-vastuussa-tekoalysta1200x630.jpg";
import imgNewsIhminenVastuussaTekoalystaSmallEng from "url:./images/news-ihminen-vastuussa-tekoalysta630x315.jpg";
import imgNewsIhminenVastuussaTekoalystaEng from "url:./images/news-ihminen-vastuussa-tekoalysta1200x630.jpg";
import imgNewsHeiKirjoitaMinulleBlogi from "url:./images/news-hei-kirjoita-minulle-blogi1200x630.jpg";
import imgNewsHeiKirjoitaMinulleBlogiSmall from "url:./images/news-hei-kirjoita-minulle-blogi630x315.jpg";
import imgNewsHeiKirjoitaMinulleBlogiEng from "url:./images/news-hei-kirjoita-minulle-blogi1200x630.jpg";
import imgNewsHeiKirjoitaMinulleBlogiSmallEng from "url:./images/news-hei-kirjoita-minulle-blogi630x315.jpg";
import imgNewsKohokohdat from "url:./images/news-kohokohdat1200x630.jpg";
import imgNewsKohokohdatSmall from "url:./images/news-kohokohdat630x315.jpg";
import imgNewsBCorpPart2 from "url:./images/news-b-corp-part-2-1200x630.jpg";
import imgNewsBCorpPart2Small from "url:./images/news-b-corp-part-2-630x315.jpg";
import imgNewsBCorpPart2Eng from "url:./images/news-b-corp-part-2-1200x630.jpg";
import imgNewsBCorpPart2SmallEng from "url:./images/news-b-corp-part-2-630x315.jpg";
import imgNewsBCorpPart2Is from "url:./images/news-b-corp-part-2-1200x630.jpg";
import imgNewsBCorpPart2SmallIs from "url:./images/news-b-corp-part-2-630x315.jpg";
import imgNewsBCorpPart2Sv from "url:./images/news-b-corp-part-2-1200x630.jpg";
import imgNewsBCorpPart2SmallSv from "url:./images/news-b-corp-part-2-630x315.jpg";
import imgNewsBCorpPart2InfographicEnglishStage8Eng from "url:./images/news-b-corp-part-2-infographic-english-stage-8-eng.png";
import imgNewsBCorpPart2InfographicEnglishStage8Suomi from "url:./images/news-b-corp-part-2-infographic-english-stage-8-suomi.png";
import imgNewsBCorpPart2InfographicEnglishStage8Sv from "url:./images/news-b-corp-part-2-infographic-english-stage-8-sv.png";
import imgNewsBCorpPart2InfographicEnglishStage8Is from "url:./images/news-b-corp-part-2-infographic-english-stage-8-eng.png";
import imgNewsPressRelease from "url:./images/news-press-release1200x630.jpg";
import imgNewsPressReleaseSmall from "url:./images/news-press-release630x315.jpg";
import imgNewsPressReleaseEng from "url:./images/news-press-release1200x630.jpg";
import imgNewsPressReleaseSmallEng from "url:./images/news-press-release630x315.jpg";
import imgNewsAasianKielet from "url:./images/aasian-kielet1200x630.jpg";
import imgNewsAasianKieletSmall from "url:./images/aasian-kielet630x315.jpg";
import imgNewsAasianKartta from "url:./images/aasian-kartta.png";
import imgNewsAasianKarttaModal from "url:./images/aasian-kartta.png";
import imgNews5hyvaaSyyta from "url:./images/news-5-hyvaa-syyta1200x630.png";
import imgNews5hyvaaSyytaSmall from "url:./images/news-5-hyvaa-syyta630x315.png";
import imgNews5hyvaaSyytaKorkeaAsiakastyytyvaisyys from "url:./images/news-5-hyvaa-syyta-korkea-asiakastyytyvaisyys.png";
import imgNews5hyvaaSyytaVastuullinenTulkkauspalvelu from "url:./images/news-5-hyvaa-syyta-vastuullinen-tulkkauspalvelu.png";
import imgNews5hyvaaSyytaUpeatYoupretTulkit from "url:./images/news-5-hyvaa-syyta-upeat-youpret-tulkit.png";
import imgNews5hyvaaSyytaEdistynytTeknologia from "url:./images/news-5-hyvaa-syyta-edistynyt-teknologia.png";
import imgNews5hyvaaSyytaErinomainenTulkkienSaatavuus from "url:./images/news-5-hyvaa-syyta-erinomainen-tulkkien-saatavuus.png";
import imgNews5goodReasons from "url:./images/news-5-hyvaa-syyta1200x630.png";
import imgNews5goodReasonsSmall from "url:./images/news-5-hyvaa-syyta630x315.png";
import imgNews5goodReasonsIs from "url:./images/news-5-hyvaa-syyta1200x630.png";
import imgNews5goodReasonsSmallIs from "url:./images/news-5-hyvaa-syyta630x315.png";
import imgNews5goodReasonsResponsibleInterpretationServices from "url:./images/news-5-good-reasons-responsible-interpretation-services.png";
import imgNews5goodReasonsCustomerSatisfaction from "url:./images/news-5-good-reasons-customer-satisfaction.png";
import imgNews5goodReasonsFantasticYoupretInterpreters from "url:./images/news-5-good-reasons-fantastic-youpret-interpreters.png";
import imgNews5goodReasons100availability from "url:./images/news-5-good-reasons-100-availability.png";
import imgNews5goodReasonsAdvancedTechnology from "url:./images/news-5-good-reasons-advanced-technology.png";
import imgNews5hyvaaSyytaSv from "url:./images/news-5-hyvaa-syyta1200x630.png";
import imgNews5hyvaaSyytaSmallSv from "url:./images/news-5-hyvaa-syyta630x315.png";
import imgNews5sv100 from "url:./images/news-5-sv-100.png";
import imgNews5sv77 from "url:./images/news-5-sv-77.png";
import imgNews5sv88 from "url:./images/news-5-sv-88.png";
import imgNews5sv68 from "url:./images/news-5-sv-68.png";
import imgNews5sv89 from "url:./images/news-5-sv-89.png";
import imgNewsYoupretHeats from "url:./images/news-youpret-heats1200x630.jpg";
import imgNewsYoupretHeatsSmall from "url:./images/news-youpret-heats630x315.jpg";
import imgNewsYoupretHeatsSmallEng from "url:./images/news-youpret-heats630x315.jpg";
import imgNewsYoupretHeatsEng from "url:./images/news-youpret-heats1200x630.jpg";
import imgNewsYoupretHeatsSmallRu from "url:./images/news-youpret-heats630x315.jpg";
import imgNewsYoupretHeatsRu from "url:./images/news-youpret-heats1200x630.jpg";
import imgNewsYoupretHeatsSmallSv from "url:./images/news-youpret-heats630x315.jpg";
import imgNewsYoupretHeatsSv from "url:./images/news-youpret-heats1200x630.jpg";
import imgNewsOurNPSis77 from "url:./images/news-our-NPS-is-77.png";
import imgNewsImportanceOfSustainability from "url:./images/news-importance-of-sustainability.png";
import imgNewsSatisfactionWithApplication from "url:./images/news-satisfaction-with-application.png";
import imgNewsSatisfactionWithHandlingOrders from "url:./images/news-satisfaction-with-handling-orders.png";
import imgNewsSatisfactionWithInterpererAvailability from "url:./images/news-satisfaction-with-interperer-availability.png";
import imgNewsSatisfactionWithQuality from "url:./images/news-satisfaction-with-quality.png";
import imgNewsSatisfactionWithSustainability from "url:./images/news-satisfaction-with-sustainability.png";
import imgNewsOurNPSis68Ru from "url:./images/news-our-NPS-is-68-ru.png";
import imgNewsApplicationRu1 from "url:./images/news-application-ru-1.png";
import imgNewsQualityRu2 from "url:./images/news-quality-ru-2.png";
import imgNewsAvailabilityRu3 from "url:./images/news-availability-ru-3.png";
import imgNewsOrdersRu4 from "url:./images/news-orders-ru-4.png";
import imgNewsImportanceRu5 from "url:./images/news-importance-ru-5.png";
import imgNewsNPSluku68 from "url:./images/news-NPS-luku-68.png";
import imgNewsAsiakkatPitaavaatVastuullisuutta from "url:./images/news-asiakkat-pitaavaat-vastuullisuutta.png";
import imgNewsTyytyvaaisyysAsiakaspalvelu from "url:./images/news-tyytyvaaisyys-asiakaspalvelu.png";
import imgNewsTyytyvaaisyysSovellukseen from "url:./images/news-tyytyvaaisyys-sovellukseen.png";
import imgNewsTyytyvaaisyysTulkkaustenLaatuun from "url:./images/news-tyytyvaaisyys-tulkkausten-laatuun.png";
import imgNewsTyytyvaaisyysTulkkienSaatavuuteen from "url:./images/news-tyytyvaaisyys-tulkkien-saatavuuteen.png";
import imgNewsOurNPSis77Sv from "url:./images/news-our-NPS-is-77-sv.png";
import imgNewsNojdhetAppSv1 from "url:./images/news-nojdhet-app-sv-1.png";
import imgNewsNojdhetKvalitetSv2 from "url:./images/news-nojdhet-kvalitet-sv-2.png";
import imgNewsNojdhetTolktillgangligSv3 from "url:./images/news-nojdhet-tolktillganglig-sv-3.png";
import imgNewsNojdhetKundtjanstensSv4 from "url:./images/news-nojdhet-kundtjanstens-sv-4.png";
import imgNewsKunderSv5 from "url:./images/news-kunder-sv-5.png";
import imgNewsYoupretTranslateSmall from "url:./images/news-youpret-translate630x315.jpg";
import imgNewsYoupretTranslate from "url:./images/news-youpret-translate1200.jpg";
import imgNewsYoupretTranslateSmallEng from "url:./images/news-youpret-translate630x315.jpg";
import imgNewsYoupretTranslateEng from "url:./images/news-youpret-translate1200.jpg";
import imgNewsKatu from "url:./images/katu1200x630.jpg";
import imgNewsKatuSmall from "url:./images/katu630x315.jpg";
import imgNewsYKO from "url:./images/monikielinen-yhteiskuntaorientaatio1200x630.jpg";
import imgNewsYKOSmall from "url:./images/monikielinen-yhteiskuntaorientaatio630x315.jpg";
import imgNewsYKOArtboard from "url:./images/news-yko-artboard.png"

import imgNewsVilppuLeinonenYoupret from "url:./images/news-vilppu-leinonen-youpret.jpg";
import imgNewsAidaJoderiYoupret from "url:./images/news-aida-joderi-youpret.jpg";
import imgHeikkiVepsalainenCeoYoupret from "url:./images/heikki-vepsalainen-ceo-youpret.png";
import imgNewsJarkkoKarjalainenYoupret from "url:./images/news-jarkko-karjalainen-youpret.png";
import imgNewsAsserKakkoYoupret1 from "url:./images/news-asser-kakko-youpret-1.png";
import imgNewsSatuPirhonenYoupretCircle from "url:./images/news-satu-pirhonen-youpret-circle.png";
import imgJuhoKekkonenYoupret1 from"url:./images/juho-kekkonen-youpret-1.png";

import imgVipuvoimaaEusta from "url:./images/vipuvoimaaeu.jpg";
import imgVipuvoimaaEusta2 from "url:./images/vipuvoimaaeu2.png";
import imgSpecialInterpreterChildhoodEducation from "url:./images/special-interpreter-childhood-education.png";
import imgSpecialInterpreterDrivingSchool from "url:./images/special-interpreter-drivingschool.png";
import imgSpecialInterpreterHealth from "url:./images/special-interpreter-health.png";
import imgSpecialInterpreterLegal from "url:./images/special-interpreter-legal.png";
import imgSpecialInterpreterBusiness from "url:./images/special-interpreter-business.png";
import imgSpecialInterpreterChildhoodEducationDe from "url:./images/special-interpreter-childhood-education-de.png";
import imgSpecialInterpreterDrivingSchoolDe from "url:./images/special-interpreter-drivingschool-de.png";
import imgSpecialInterpreterHealthDe from "url:./images/special-interpreter-health-de.png";
import imgSpecialInterpreterLegalDe from "url:./images/special-interpreter-legal-de.png";
import imgSpecialInterpreterBusinessDe from "url:./images/special-interpreter-business-de.png";
import imgSpecialInterpreterChildhoodEducationRu from "url:./images/special-interpreter-childhood-education-ru.png";
import imgSpecialInterpreterDrivingSchoolRu from "url:./images/special-interpreter-drivingschool-ru.png";
import imgSpecialInterpreterHealthRu from "url:./images/special-interpreter-health-ru.png";
import imgSpecialInterpreterLegalRu from "url:./images/special-interpreter-legal-ru.png";
import imgSpecialInterpreterBusinessRu from "url:./images/special-interpreter-business-ru.png";
import imgBusinessInterpreterBanner from "url:./images/business-interpreter-banner1200x630.png";
import imgBusinessInterpreterBannerSmall from "url:./images/business-interpreter-banner630x315.png";
import imgBusinessInterpreterHandsBanner from "url:./images/business-interpreter-hands-banner1200x630.png";
import imgBusinessInterpreterHandsBannerSmall from "url:./images/business-interpreter-hands-banner630x315.png";
import imgBusinessInterpreterBanner2 from "url:./images/business-interpreter1200x630.jpg";
import imgBusinessInterpreterBanner2Small from "url:./images/business-interpreter630x315.png";
import imgAcademyPhones from "url:./images/academy-phones.png";
import imgAcademyPhone from "url:./images/academy-phone.jpg";
import imgAcademyCourseTool from "url:./images/academy-course-tool.jpg";
import imgAcademyCourseSocial from "url:./images/academy-course-social.png";
import imgAcademyLMS from "url:./images/academy-lms.jpg";
import imgAcademySupport from "url:./images/academy-support.jpg";
import imgAcademyIntra from "url:./images/academy-intra.jpg";
import imgAcademyFast from "url:./images/academy-fast.png";
import imgAcademyHand from "url:./images/academy-hand.jpg";
import imgAcademySuit from "url:./images/academy-suit.jpg";
import imgAcademyLaptop from "url:./images/academy-laptop.png";
import imgAcademyLogoWhite from "url:./images/academy-logo-white.png";
import imgAcademyLogoBlue from "url:./images/academy-logo-blue.png";
import imgAcademyLogoBlueSecondary from "url:./images/academy-logo-blue.png";
import imgAcademyScreen2 from "url:./images/academy-screen-2.png";
import imgAcademyScreen1 from "url:./images/academy-screen-1.png";
import imgYoupretWorkplace from "url:./images/youpret-workplace.jpg";
import imgYoupretWorkEnvironment from "url:./images/youpret-workenvironment.png";
import imgYoupretJobOffice from "url:./images/youpret-job-office.jpg";
import imgYoupretJobOfficeMobile from "url:./images/youpret-job-office.jpg";
import imgTechnologyStreamline from "url:./images/technology-streamline.jpg";
import imgTechnologyUses from "url:./images/technology-uses.png";
import imgTechnologyAccessible from "url:./images/technology-accessible.png";
import imgTechnologyAutomatic from "url:./images/technology-automatic.png";
import imgTechnologyGrow from "url:./images/technology-grow.png";
import imgTechnologyOversee from "url:./images/technology-oversee.png";
import imgTechnologySystem from "url:./images/technology-system.png";
import imgTechnologyNetwork from "url:./images/technology-network.jpg";
import imgHarnessLanguageTechnologyBackground from "url:./images/harness-language-technology-background.png";
import imgHarnessLanguageTechnologyBlack from "url:./images/harness-language-technology-black.png";
import imgHarnessLanguageTechnologyBlackMobile from "url:./images/harness-language-technology-black.png";
import imgHarnessLanguageTechnologyAbstractBackground from "url:./images/harness-language-technology-abstract-background.png";
import imgHarnessLanguageTechnologyAbstractBackgroundMobile from "url:./images/harness-language-technology-abstract-background.png";
import imgHarnessLanguageTechnologyAbstNew from "url:./images/harness-language-technology-abst-new.png";
import imgHarnessLanguageTechnologyAbstractPlexusBlue from "url:./images/harness-language-technology-abstract-plexus-blue.png";
import imgHarnessLanguageTechnologyAbstractPlexusBlueMobile from "url:./images/harness-language-technology-abstract-plexus-blue.png";
import imgCustomersGuide from "url:./images/customers-guide.png";
import imgApplyInterpreter from "url:./images/apply-interpreter.jpg";
import imgYoupretOffers from "url:./images/youpret-offers.png";
import svgInterpreterMobile from "url:./images/interpreter-mobile.svg";
import svgInterpreterApp from "url:./images/interpreter-app.svg";
import svgInterpreterSilent from "url:./images/interpreter-silent.svg";
import imgYoupretLanguage from "url:./images/youpret-language.jpg";
import imgYoupretInfograph from "url:./images/youpret-infograph.png";
import imgYoupretInfographEn from "url:./images/youpret-infograph-en.png";
import imgYoupretLogoGallery from "url:./images/youpret-logo-gallery.png";
import imgYoupretImageGallery from "url:./images/youpret-image-gallery.png";
import imgSustainabilityMaskGroup from "url:./images/sustainability-mask-group.png";
import imgSustainabilityArtboard from "url:./images/sustainability-artboard.png";
import imgVastuullisuusRaporttiFi from "url:./images/vastuullisuus-raportti-fi.png";
import imgYoupretLogoThanks from "url:./images/youpret-logo-web-72dpi-500x500.png"

import imgBcorpSecondPart1fi from "url:./images/bcorp-second-part-1-fi.png";
import imgBcorpFirstPart1fi from "url:./images/bcorp-first-part-1-fi.png";
import imgSustainabilityCertificate1fi from "url:./images/sustainability-certificate-1-fi.png";
import imgBcorpSecondPart1eng from "url:./images/bcorp-second-part-1-eng.png";
import imgBcorpFirstPart1eng from "url:./images/bcorp-first-part-1-eng.png";
import imgSustainabilityCertificate1eng from "url:./images/sustainability-certificate-1-eng.png";
import imgSustainabilityCertificate1sv from "url:./images/sustainability-certificate-1-sv.png";


import softwarePageBanner from "url:./images/software-banner.jpg";
import softwarePageContentImage from "url:./images/software-content.jpg";
import softwarePagePhone from "url:./images/software-phone.png";

import imgLogoEspoo from "url:./images/logo-espoo.png";
import imgLogoHorizontal from "url:./images/logo-horizontal.png";
import imgLogoHyria from "url:./images/logo-hyria.png";
import imgLogoJoensuu from "url:./images/logo-joensuu.png";
import imgLogoJoensuu1 from "url:./images/logo-joensuu.png";
import imgLogoKeskiUudenmaaHyvinvointialue from "url:./images/logo-keski-uudenmaa-hyvinvointialue.png";
import imgLogoKeskiUudenmaaHyvinvointialue1 from "url:./images/logo-keski-uudenmaa-hyvinvointialue.png";
import imgLogoMehilainen from "url:./images/logo-mehilainen.png";
import imgLogoPihlaGroup from "url:./images/logo-pihla-group.png";
import imgLogoPorokylanLeipomo from "url:./images/logo-porokylan-leipomo.png";
import imgLogoSiunSote from "url:./images/logo-siun-sote.png";
import imgLogoTeToimisto from "url:./images/logo-te-toimisto.png";
import imgLogoTeToimisto1 from "url:./images/logo-te-toimisto.png";
import imgLogoThl from "url:./images/logo-thl.png";
import imgLogoThl1 from "url:./images/logo-thl.png";
import imgLogoTuisku from "url:./images/logo-tuisku.jpg";
import imgLogoSuomenYrittajat from "url:./images/logo-suomen-yrittajat.png";
import imgLogoLayer from "url:./images/logo-layer.png";
import imgLogoSkyRound from "url:./images/logo-sky-round.png";
import imgLogoKela from "url:./images/logo-kela.png";
import imgLogoKelaMobile from "url:./images/logo-kela.png";
import imgLogoPilke from "url:./images/logo-pilke.png";
import imgLogoPilkeMobile from "url:./images/logo-pilke.png";
import imgLogoMigri from "url:./images/logo-migri.png";
import imgLogoMigriMobile from "url:./images/logo-migri.png";
import imgLogoBCorpTagline from "url:./images/logo-b-corp-tagline.png";
import imgLogoBCorpTaglineMobile from "url:./images/logo-b-corp-tagline.png";
import imgLogoKestavanKehityksenTavoitteet from "url:./images/logo-kestavan-kehityksen-tavoitteet.png";
import imgLogoSustainabilityGoalsEng from "url:./images/logo-sustainability-goals-eng.png";
import imgLogoKauppakamari from "url:./images/logo-kauppakamari.png";
import imgLogoKauppakamariMobile from "url:./images/logo-kauppakamari.png";
import imgLogoGlobalaMalenHorizontellSv from "url:./images/logo-globala-malen-horizontell-sv.png";

import imgStreamlinedMobileAppPromo from "url:./images/streamlined-mobile-app-promo.png";
import imgStreamlinedTypingKeyboard from "url:./images/streamlined-typing-keyboard.png";
import imgStreamlinedTypingKeyboardMobile from "url:./images/streamlined-typing-keyboard.png";
import imgStreamlinedManagementCustomerFriendly from "url:./images/streamlined-management-customer-friendly.png";
import imgStreamlinedManagementCustomerFriendlyMobile from "url:./images/streamlined-management-customer-friendly.png";
import imgStreamlinedManagementWhiteLabeling from "url:./images/streamlined-management-white-labeling.png";
import imgStreamlinedManagementWhiteLabelingMobile from "url:./images/streamlined-management-white-labeling.png";
import imgStreamlinedManagementClearOverview from "url:./images/streamlined-management-clear-overview.png";
import imgStreamlinedManagementClearOverviewMobile from "url:./images/streamlined-management-clear-overview.png";
import imgStreamlinedManagementProvenSolution from "url:./images/streamlined-management-proven-solution.png";
import imgStreamlinedManagementProvenSolutionMobile from "url:./images/streamlined-management-proven-solution.png";
import imgStreamlinedManagementAutomatedSystem from "url:./images/streamlined-management-automated-system.png";
import imgStreamlinedManagementAutomatedSystemMobile from "url:./images/streamlined-management-automated-system.png";
import imgStreamlinedManagementCompanyPlatform from "url:./images/streamlined-management-company-platform.png";
import imgStreamlinedManagementCompanyPlatformMobile from "url:./images/streamlined-management-company-platform.png";
import imgCustomersStoriesBg from "url:./images/customers-stories-bg.png";
import imgTranslatorBackgroundKeyboard from "url:./images/translator-background-keyboard.png";
import imgApplyAsTranslatorHeadphones from "url:./images/apply-as-translator-headphones.png";

import imgLogoEspooMobile from "url:./images/logo-espoo.png";
import imgLogoHorizontalMobile from "url:./images/logo-horizontal.png";
import imgLogoHyriaMobile from "url:./images/logo-hyria.png";
import imgLogoJoensuuMobile from "url:./images/logo-joensuu.png";
import imgLogoKeskiUudenmaaHyvinvointialueMobile from "url:./images/logo-keski-uudenmaa-hyvinvointialue.png";
import imgLogoMehilainenMobile from "url:./images/logo-mehilainen.png";
import imgLogoPihlaGroupMobile from "url:./images/logo-pihla-group.png";
import imgLogoSiunSoteMobile from "url:./images/logo-siun-sote.png";
import imgLogoTeToimistoMobile from "url:./images/logo-te-toimisto.png";
import imgLogoThlMobile from "url:./images/logo-thl.png";
import imgLogoTuiskuMobile from "url:./images/logo-tuisku.jpg";
import imgLogoSuomenYrittajatMobile from "url:./images/logo-suomen-yrittajat.png";
import imgLogoLayerMobile from "url:./images/logo-layer.png";
import imgLogoSkyRoundMobile from "url:./images/logo-sky-round.png";
import imgLogoPunainenRisti from "url:./images/logo-punainen-risti.png";
import imgLogoPunainenRistiMobile from "url:./images/logo-punainen-risti.png";
import imgLogoEkhva from "url:./images/logo-ekhva.png";
import imgLogoEkhvaMobile from "url:./images/logo-ekhva.png";
import imgLogoEkhva1 from "url:./images/logo-ekhva.png";
import imgLogoEkhva1Mobile from "url:./images/logo-ekhva.png";
import imgLogoLappeenranta from "url:./images/logo-lappeenranta.png";
import imgLogoLappeenrantaMobile from "url:./images/logo-lappeenranta.png";
import imgLogoHameenlinnanKaupunki from "url:./images/logo-hameenlinnan-kaupunki.png";
import imgLogoHameenlinnanKaupunkiMobile from "url:./images/logo-hameenlinnan-kaupunki.png";
import imgLogoYoupretStreamlined from "url:./images/logo-youpret-streamlined.png";
import imgLogoYoupretStreamlinedMobile from "url:./images/logo-youpret-streamlined.png";
import imgLogoKotokunta from "url:./images/logo-kotokunta.png";
import imgLogoKotokuntaMobile from "url:./images/logo-kotokunta.png";
import imgLogoKotokunta from "url:./images/logo-kotokunta.png";
import imgLogoKotokuntaMobile from "url:./images/logo-kotokunta.png";
import imgLogoKotokunta from "url:./images/logo-kotokunta.png";
import imgLogoKotokuntaMobile from "url:./images/logo-kotokunta.png";
import imgLogoKotokunta from "url:./images/logo-kotokunta.png";
import imgLogoKotokuntaMobile from "url:./images/logo-kotokunta.png";
import imgLogoTivi from "url:./images/youpret-logo-tivi.png";
import imgLogoKarjalainen from "url:./images/youpret-logo-karjalainen.png";
import imgLogoHeili from "url:./images/youpret-logo-heili.png";
import imgLogoKauppalehti from "url:./images/youpret-logo-kauppalehti.png";
import imgLogoTyohame from "url:./images/tyohame-logo.png";
import imgLogoTyohameMobile from "url:./images/tyohame-logo.png";
import imgLogoKela from "url:./images/kela-logo.png";
import imgLogoKelaMobile from "url:./images/kela-logo.png";

import imgAidaBlockAuthor from "url:./images/aida-block-author.png";
import imgNeaBlockAuthor from "url:./images/nea-block-author.png";
import imgVilppuBlockAuthor from "url:./images/vilppu-block-author.png";

import svgAppointment from "url:./images/appointment.svg";
import svgCalendar from "url:./images/calendar.svg";
import svgCustomer from "url:./images/customer.svg";
import svgCustomerService from "url:./images/customer-service.svg";
import svgEdit from "url:./images/edit.svg";
import svgEndless from "url:./images/endless.svg";
import svgIconOnsite from "url:./images/onsite.svg";
import svgImmigration from "url:./images/immigration.svg";
import svgMenu from "url:./images/menu.svg";
import svgNewspaperFolded from "url:./images/newspaper-folded.svg";
import svgOnlineTest from "url:./images/online-test.svg";
import svgSecureShield from "url:./images/secure-shield.svg";
import svgTickMark from "url:./images/tick-mark.svg";
import svgTranslation from "url:./images/translation.svg";
import svgYoupret from "url:./images/youpret.svg";
import svgSmartphone from "url:./images/smartphone.svg";
import svgYoupretAcademyLogo from "url:./images/youpret-academy-logo.svg";
import svgAcademyApplication from "url:./images/academy-application.svg";
import svgAcademyUser from "url:./images/academy-user.svg";
import svgAcademyCourses from "url:./images/academy-courses.svg";
import svgAcademyComputer from "url:./images/academy-computer.svg";
import svgBarGreen from "url:./images/bar-green.svg";
import svgBarYellow from "url:./images/bar-yellow.svg";
import svgBarTopYellow from "url:./images/bar-top-yellow.svg";
import svgBarTopGreen from "url:./images/bar-top-green.svg";
import svgTechnologyConnect from "url:./images/technology-connect.svg";
import svgTechnologyEasy from "url:./images/technology-easy.svg";
import svgTechnologyChoose from "url:./images/technology-choose.svg";
import svgTechnologyAssignments from "url:./images/technology-assignments.svg";
import svgTechnologyTime from "url:./images/technology-time.svg";
import svgTechnologyReceive from "url:./images/technology-receive.svg";
import svgArrowUp from "url:./images/arrow_up.svg";
import svgArrowUp1 from "url:./images/arrow_up.svg";
import svgGlobe from "url:./images/globe.svg";
import svgMentalHealth from "url:./images/mental-health.svg";
import svgMentalHealthService from "url:./images/mental-health-service.svg";

import svgShortDays from "url:./images/svg-short-days.svg";
import svgShortLanguages from "url:./images/svg-short-languages.svg";
import svgShortMonth from "url:./images/svg-short-month.svg";
import svgShortFounded from "url:./images/svg-short-founded.svg";
import svgShortInterpreters from "url:./images/svg-short-interpreters.svg";
import svgShortBcorp from "url:./images/svg-short-bcorp.svg";

import imgAcademyCourse1 from "url:./images/academy-course-1.png";
import imgAcademyCourse2 from "url:./images/academy-course-2.png";
import imgAcademyCourse3 from "url:./images/academy-course-3.png";
import imgAcademyCourseMental from "url:./images/academy-course-mental.png";
import imgOpenJobsManFront from "url:./images/open-jobs-man-front.jpg";
import imgOpenJobsManBack from "url:./images/open-jobs-man-back.jpg";
import imgYoupretCoffeeBreak1 from "url:./images/youpret-coffee-break-1.png";
import imgYoupretWomanWorking from "url:./images/youpret-woman-working.png";
import imgYoupretWomanSmiling from "url:./images/youpret-woman-smiling.png";
import imgYoupretWomanHeadphones from "url:./images/youpret-woman-headphones.png";
import imgMobileAppPromo from "url:./images/mobile-app-promo.png";
import imgAsiakaspalveluHarjoittelijaJobOfferBanner from "url:./images/asiakaspalvelu-harjoittelija-job-offer1200x630.png";
import imgAsiakaspalveluJobOfferBanner from "url:./images/asiakaspalvelu-job-offer1200x630.png";
import imgMentalHealthRibbon from "url:./images/mental-health-ribbon.png";
import imgMentalHealthUseful from "url:./images/mental-health-useful.png";
import imgVerttiKypara from "url:./images/vertti-kypara.jpg";
import imgSpecialistMentalHealth from "url:./images/specialist-mental-health.png";
import imgInterpreterChecklist from "url:./images/interpreter-checklist.png";
import imgInterpreterChecklistInfograph from "url:./images/interpreter-checklist-infograph.png";
import imgCompensationBg from "url:./images/compensation-bg.png";
import imgOrderTranslation from "url:./images/order-translation.png";
import imgOrientationEasy from "url:./images/orientation-easy.png";
import imgOrientationKey from "url:./images/orientation-key.png";
import imgOrientation1 from "url:./images/orientation-1.svg";
import imgOrientation2 from "url:./images/orientation-2.svg";
import imgOrientation3 from "url:./images/orientation-3.svg";
import imgOrientation4 from "url:./images/orientation-4.svg";
import imgOrientation5 from "url:./images/orientation-5.svg";
import imgOrientation1Mobile from "url:./images/orientation-1.svg";
import imgOrientation2Mobile from "url:./images/orientation-2.svg";
import imgOrientation3Mobile from "url:./images/orientation-3.svg";
import imgOrientation4Mobile from "url:./images/orientation-4.svg";
import imgOrientation5Mobile from "url:./images/orientation-5.svg";
import imgOrientationService from "url:./images/orientation-service.png";
import imgTranslatorApply from "url:./images/translator-apply.png";
import imgTranslatorJoin from "url:./images/translator-join.png";
import imgTranslatorRequire from "url:./images/translator-require.png";
import imgTranslatorWhy from "url:./images/translator-why.png";
import imgTranslatorWhyMobile from "url:./images/translator-why.png";
import imgTranslatorAsser from "url:./images/translator-asser.png";
import imgShortCustomers from "url:./images/youpret-short-customers.png";
import imgShortStory from "url:./images/youpret-short-story.png";
import imgShortStoryMobile from "url:./images/youpret-short-story.png";
import imgShortPhone from "url:./images/youpret-short-phone.png";
import imgBcorpDegrees from "url:./images/bcorp-degrees.png";
import imgBcorpBusiness from "url:./images/bcorp-business.png";
import imgBcorpFair from "url:./images/bcorp-fair.png";
import imgBcorpWhy from "url:./images/bcorp-why.png";
import imgBcorpPositive from "url:./images/bcorp-positive.png";
import imgBcorpPositiveEn from "url:./images/bcorp-positive-en.png";
import imgBcorpPositiveSv1 from "url:./images/bcorp-positive-sv1.png";
import imgBcorpCommitted from "url:./images/bcorp-committed.png";
import imgBcorpReport from "url:./images/bcorp-report.png";
import imgBcorpBlog from "url:./images/bcorp-blog.png";
import imgBcorpCustomers from "url:./images/bcorp-customers.svg";
import imgBcorpCommunity from "url:./images/bcorp-community.svg";
import imgBcorpPeople from "url:./images/bcorp-people.svg";
import imgBcorpCovernance from "url:./images/bcorp-covernance.svg";
import imgBcorpEnvironment from "url:./images/bcorp-environment.svg";
import imgBcorpHandbook from "url:./images/bcorp-handbook.png";
import imgBcorpDeclaration from "url:./images/bcorp-declaration.png";
import imgBcorpHandbookEn from "url:./images/bcorp-handbook-en.png";
import imgBcorpReportEn from "url:./images/bcorp-report-en.png";
import imgBcorpBlogEn from "url:./images/bcorp-blog-en.png";
import imgBcorpHandbookSv from "url:./images/bcorp-handbook-sv.png";
import imgBcorpReportSv from "url:./images/bcorp-report-sv.png";
import imgBcorpBlogSv from "url:./images/bcorp-blog-sv.png";
import imgBcorpLogo from "url:./images/bcorp-logo.png";
import imgBcorpLogoSecondary from "url:./images/bcorp-logo.png";
import imgBcorpLogoSecondaryMobile from "url:./images/bcorp-logo.png";
import imgTranslationLanguagesMain from "url:./images/translation-languages-main.png";
import imgSoteMain from "url:./images/sote-main.png";
import imgLanguagePagesOrder from "url:./images/language-pages-order.png";
import imgLanguagePagesAi from "url:./images/language-pages-ai.png";
import imgCleaningMain from "url:./images/siivous-kampanja.png";



// Stories images
import imgCareerStories from "url:./images/career-stories.png";
import imgStoriesCheerman from "url:./images/stories-cheerman.png";
import imgStoriesCheermanSmall from "url:./images/stories-cheerman-small.png";
import imgStoriesCheemanTahir from "url:./images/stories-cheeman-tahir.png";
import imgStoriesCheemanTahir1 from "url:./images/stories-cheeman-tahir-1.png";
import imgStoriesCheemanTahir2 from "url:./images/stories-cheeman-tahir-2.png";
import imgStoriesCheemanTahir3 from "url:./images/stories-cheeman-tahir-3.png";
import imgStoriesCheemanTahir4 from "url:./images/stories-cheeman-tahir-4.png";
import imgStoriesJukkaKylmalaBg from "url:./images/stories-jukka-kylmala-bg.png";
import imgStoriesJukkaKylmalaSmall from "url:./images/stories-jukka-kylmala-small.png";
import imgStoriesJukkaKylmala1 from "url:./images/stories-jukka-kylmala-1.png";
import imgStoriesJukkaKylmala2 from "url:./images/stories-jukka-kylmala-2.png";
import imgStoriesJukkaKylmala3 from "url:./images/stories-jukka-kylmala-3.png";
import imgStoriesJukkaKylmala4 from "url:./images/stories-jukka-kylmala-4.png";
import imgStoriesJukkaKylmala5 from "url:./images/stories-jukka-kylmala-5.png";
import imgStoriesAliHokkaBg from "url:./images/stories-ali-hokka-bg.png";
import imgStoriesAliHokkaSmall from "url:./images/stories-ali-hokka-small.png";
import imgStoriesAliHokka1stone from "url:./images/stories-ali-hokka-1-stone.png";
import imgStoriesAliHokka2birches from "url:./images/stories-ali-hokka-2-birches.png";
import imgStoriesAliHokka3forest from "url:./images/stories-ali-hokka-3-forest.png";
import imgStoriesAliHokka4phone from "url:./images/stories-ali-hokka-4-phone.png";
import imgStoriesAliHokka5computer from "url:./images/stories-ali-hokka-5-computer.png";
import imgStoriesAljaSkottiBg from "url:./images/stories-alja-skotti-bg.png";
import imgStoriesAljaSkottiSmall from "url:./images/stories-alja-skotti-small.png";
import imgStoriesAljaSkotti1onABreakTest from"url:./images/stories-alja-skotti-1-on-a-break-test.png";
import imgStoriesAljaSkotti2walking from"url:./images/stories-alja-skotti-2-walking.png";
import imgStoriesAljaSkotti3sitting from"url:./images/stories-alja-skotti-3-sitting.png";
import imgStoriesAljaSkotti4bridge from"url:./images/stories-alja-skotti-4-bridge.png";
import imgStoriesAljaSkotti5riverside from"url:./images/stories-alja-skotti-5-riverside.png";
import imgStoriesAljaSkotti6writing from"url:./images/stories-alja-skotti-6-writing.png";
import imgStoriesAljaSkotti7office from"url:./images/stories-alja-skotti-7-office.png";
import imgStoriesAljaSkotti8smilingTest from"url:./images/stories-alja-skotti-8-smiling-test.png";
import imgStoriesAljaSkotti9working from"url:./images/stories-alja-skotti-9-working.png";


// Meta img
import imgyplogoog from "url:./images/youpret-logo-og.jpg";
import imgNewsAcademyMeta from "url:./images/youpret-academy-blog1200x630.jpg";
import imgNewsTulkkienKoulutusMeta from "url:./images/tulkkien-koulutus1200x630.jpg";
import imgNewsSurveyMeta from "url:./images/youpret-interpreter-survey1200x630.png";
// Afrikan kartta download
import imgafrikankarttadownload from "url:./images/afrikan-kartta.jpg";

// Videos

import mp4AcademyLoop from "url:./images/academy-loop.mp4";


setImage("svg_appointment", svgAppointment);
setImage("svg_calendar", svgCalendar);
setImage("svg_customer", svgCustomer);
setImage("svg_customer_service", svgCustomerService);
setImage("svg_edit", svgEdit);
setImage("svg_endless", svgEndless);
setImage("svg_immigration", svgImmigration);
setImage("svg_menu", svgMenu);
setImage("svg_icon_onsite", svgIconOnsite);
setImage("svg_newspaper_folded", svgNewspaperFolded);
setImage("svg_online_test", svgOnlineTest);
setImage("svg_secure_shield", svgSecureShield);
setImage("svg_tick_mark", svgTickMark);
setImage("svg_translation", svgTranslation);
setImage("svg_youpret", svgYoupret);
setImage("svg_smartphone", svgSmartphone);
setImage("svg_star", svgStar);
setImage("svg_right_arrow", svgRightArrow);
setImage("svg_youpret_academy_logo", svgYoupretAcademyLogo);
setImage("svg_academy_application", svgAcademyApplication);
setImage("svg_academy_user", svgAcademyUser);
setImage("svg_academy_courses", svgAcademyCourses);
setImage("svg_academy_computer", svgAcademyComputer);
setImage("svg_bar_green", svgBarGreen);
setImage("svg_bar_yellow", svgBarYellow);
setImage("svg_bar_top_yellow", svgBarTopYellow);
setImage("svg_bar_top_green", svgBarTopGreen);
setImage("svg_technology_connect", svgTechnologyConnect);
setImage("svg_technology_easy", svgTechnologyEasy);
setImage("svg_technology_choose", svgTechnologyChoose);
setImage("svg_technology_assignments", svgTechnologyAssignments);
setImage("svg_technology_time", svgTechnologyTime);
setImage("svg_technology_receive", svgTechnologyReceive);
setImage("svg_globe", svgGlobe);
setImage("svg_mental_health", svgMentalHealth);
setImage("svg_mental_health_service", svgMentalHealthService);
setImage("img_icon_order_translation", imgIconOrderTranslation);
setImage("svg_short_days", svgShortDays);
setImage("svg_short_languages", svgShortLanguages);
setImage("svg_short_month", svgShortMonth);
setImage("svg_short_founded", svgShortFounded);
setImage("svg_short_interpreters", svgShortInterpreters);
setImage("svg_short_bcorp", svgShortBcorp);

// Manual
setImage("img_manual_wait_interpreter", imgManualWaitForInterpreter);
setImage("img_manual_instant_interpreter", imgManualInstantInterpreter);
setImage("img_manual_online_booking", imgManualOnlineBooking);
setImage("img_manual_review_instant_interpretation", imgManualReviewInstantInterpretation);
setImage("img_manual_review_online_interpretation", imgManualReviewOnlineInterpretation);
setImage("img_manual_add_note_instant_interpretation", imgManualAddNoteInstantInterpretation);
setImage("img_manual_add_note_online_interpretation", imgManualAddNoteOnlineInterpretation);
setImage("img_manual_add_note_online_after", imgManualAddNoteOnlineAfter);
setImage("img_apply_as_translator_headphones", imgApplyAsTranslatorHeadphones);

setImage("img_logo", imgLogo);
setImage("img_icon_instant", imgIconInstant);
setImage("img_icon_booking", imgIconBooking);
setImage("img_icon_system", imgIconSystem);
setImage("img_icon_translations", imgIconTranslations);
setImage("img_icon_facebook", imgIconFacebook);
setImage("img_icon_instagram", imgIconInstagram);
setImage("img_icon_twitter", imgIconTwitter);
setImage("img_icon_youtube", imgIconYoutube);
setImage("img_icon_tiktok", imgIconTiktok);
setImage("img_icon_tiktok_secondary", imgIconTiktokSecondary);
setImage("img_icon_youtube_secondary", imgIconYoutubeSecondary);
setImage("img_icon_linkedin", imgIconLinkedIn);
setImage("img_icon_facebook_secondary", imgIconFacebookSecondary);
setImage("img_icon_instagram_secondary", imgIconInstagramSecondary);
setImage("img_icon_twitter_secondary", imgIconTwitterSecondary);
setImage("img_icon_linkedin_secondary", imgIconLinkedInSecondary);
setImage("img_icon_facebook_another", imgIconFacebookAnother);
setImage("img_icon_instagram_another", imgIconInstagramAnother);
setImage("img_icon_twitter_another", imgIconTwitterAnother);
setImage("img_icon_linkedin_another", imgIconLinkedInAnother);
setImage("img_google_play_badge", imgGooglePlayBadge);
setImage("img_google_play_badge_2", imgGooglePlayBadge2);
setImage("img_google_play_badge_sv", imgGooglePlayBadgeSv);
setImage("img_apple_badge_fi", imgAppleBadgeFi);
setImage("img_apple_badge_fi_2", imgAppleBadgeFi2);
setImage("img_avainlippu", imgAvainlippu);
setImage("img_avainlippu_secondary", imgAvainlippuSecondary);
setImage("img_avainlippu_mobile", imgAvainlippuMobile);
setImage("img_icon_eriarvoisuus", imgIconEriarvoisuus);
setImage("img_icon_decent_work", imgIconDecentWork);
setImage("img_icon_tyo_ja_talouskasvu", imgIconTyoJaTalouskasvu);
setImage("img_icon_teollisuus_ja_infra", imgIconTeollisuusJaInfra);
setImage("img_icon_koulutus", imgIconKoulutus);
setImage("img_icon_god_utbildning_for_alla", imgIconGodUtbildningForAlla);
setImage("img_icon_anstandiga_arbetsvillkor_och_ekonomisk_tillvaxt", imgIconAnstandigaArbetsvillkorOchEkonomiskTillvaxt);
setImage("img_icon_hallbar_industri_innovationer_och_infrastruktur", imgIconHallbarIndustriInnovationerOchInfrastruktur);
setImage("img_icon_minskad_ojamnlikhet", imgIconMinskadOjamnlikhet);


setImage("img_icon_quality_education", imgIconQualityEducation);
setImage("img_icon_reduced_inequalities", imgIconReducedInequalities);
setImage("img_icon_industry_innovation", imgIconIndustryInnovation);

setImage("img_news_icon_eriarvoisuus", imgNewsIconEriarvoisuus);
setImage("img_news_icon_teollisuus_ja_infra", imgNewsIconTeollisuusJaInfra);
setImage("img_news_icon_tyo_ja_talouskasvu", imgNewsIconTyoJaTalouskasvu);
setImage("img_news_icon_tyo_ja_talouskasvu_1", imgNewsIconTyoJaTalouskasvu1);
setImage("img_news_icon_hyva_koulutus", imgNewsIconHyvaKoulutus);
setImage("img_news_icon_industry_and_infrastructure", imgNewsIconIndustryAndInfrastructure);
setImage("img_news_icon_reduced_inequalities", imgNewsIconReducedInequalities);
setImage("img_news_icon_decent_work_and_economic_growth", imgNewsIconDecentWorkAndEconomicGrowth);
setImage("img_news_icon_decent_work_and_economic_growth_1", imgNewsIconDecentWorkAndEconomicGrowth1);


setImage("img_icon_onsite", imgIconOnSite);






setImage("img_donation", imgDonation);
setImage("img_visma_logo", imgVismaLogo);

// home page images
setImage("img_home_main", imgHomeMain);
setImage("img_home_to_who", imgToWho);
setImage("img_home_youpret_hand", imgYoupretHand);
setImage("img_home_youpret_premium", imgPremiumHandshake);

// news images.
setImage("img_news_vinkit_kotona_tulkkaaville", imgNewsViisiVinkkiaKotonaTulkkaaville);
setImage("img_news_vinkit_kotona_tulkkaaville_small", imgNewsViisiVinkkiaKotonaTulkkaavilleSmall);
setImage("img_news_tiedote_youpret_lahjoittaa", imgNewsYoupretLahjoittaa);
setImage("img_news_tiedote_youpret_lahjoittaa_small", imgNewsYoupretLahjoittaaSmall);
setImage("img_news_korona", imgNewsKorona);
setImage("img_news_korona_small", imgNewsKoronaSmall);
setImage("img_news_vinkit", imgNewsVinkit);
setImage("img_news_vinkit_small", imgNewsVinkitSmall);
setImage("img_news_vinkit1", imgNewsVinkit1);
setImage("img_news_vinkit2", imgNewsVinkit2);
setImage("img_news_vinkit3", imgNewsVinkit3);
setImage("img_news_vinkit4", imgNewsVinkit4);
setImage("img_news_vinkit5", imgNewsVinkit5);
setImage("img_news_vinkit6", imgNewsVinkit6);
setImage("img_news_miten_tukea_oppilasta", imgNewsMitenTukea);
setImage("img_news_miten_tukea_oppilasta_small", imgNewsMitenTukeaSmall);
setImage("img_news_ita_uudenmaa", imgNewsItaUudenmaa);
setImage("img_news_ita_uudenmaa_small", imgNewsItaUudenmaaSmall);
setImage("img_news_miten_tukea_suvi", imgNewsMitenTukeaSuvi);
setImage("img_news_rare_languages", imgNewsRareLanguages);
setImage("img_news_rare_languages_small", imgNewsRareLanguagesSmall);
setImage("img_news_afrika_banner", imgNewsAfrikaBanner);
setImage("img_news_afrika_banner_small", imgNewsAfrikaBannerSmall);
setImage("img_news_afrika_map", imgNewsAfrikaMap);
setImage("img_news_africa-banner_eng", imgNewsAfricaBannerEng);
setImage("img_news_africa_banner_small_eng", imgNewsAfricaBannerSmallEng);
setImage("img_news_africa_map_eng", imgNewsAfricaMapEng);
setImage("img_news_interpreters_recommend_small", imgNewsInterpretersRecommendSmall);
setImage("img_news_interpreters_recommend", imgNewsInterpretersRecommend);
setImage("img_news_accounting_small", imgNewsAccountingSmall);
setImage("img_news_accounting", imgNewsAccounting);
setImage("img_news_tulkkien_koulutus_small", imgNewsTulkkienKoulutusSmall);
setImage("img_news_tulkkien_koulutus", imgNewsTulkkienKoulutus);
setImage("img_news_academy_small", imgNewsAcademySmall);
setImage("img_news_academy", imgNewsAcademy);
setImage("img_custom_reference_eksote", imgCustomReferenceEksote);
setImage("img_custom_reference_eksote_small", imgCustomReferenceEksoteSmall);
setImage("img_custom_reference_rauma", imgCustomReferenceRauma);
setImage("img_custom_reference_rauma_small", imgCustomReferenceRaumaSmall);
setImage("img_news_kieliettan", imgNewsKieliEttan);
setImage("img_news_kieliettan_small", imgNewsKieliEttanSmall);
setImage("img_recruitment", imgRecruitment);
setImage("img_recruitment_small", imgRecruitmentSmall);
setImage("img_suosikkitulkki", imgSuosikkitulkki);
setImage("img_suosikkitulkki_small", imgSuosikkitulkkiSmall);
setImage("img_dragons_den_after", imgDragonsDenAfter);
setImage("img_dragons_den_after_small", imgDragonDenAfterSmall);
setImage("img_coordinator", imgCoordinator);
setImage("img_coordinator_small", imgCoordinatorSmall);
setImage("img_jani_kamarainen", imgJaniKamarainen);
setImage("img_tulkkitapaaminen_yhteiskuva", imgTulkkitapaaminenYhteiskuva); 
setImage("img_tulkkitapaaminen_yhteiskuva_small",imgTulkkitapaaminenYhteiskuvaSmall); 
setImage("img_arabic",imgArabic); 
setImage("img_arabic_small",imgArabicSmall); 
setImage("img_youpret_interpreter",imgYoupretInterpreter); 
setImage("img_leijonan_luola",imgLeijonanLuola);
setImage("img_leijonan_luola_small",imgLeijonanLuolaSmall); 
setImage("img_why_youpret",imgWhyYoupret); 
setImage("img_why_youpret_small",imgWhyYoupretSmall); 
setImage("img_why_youpret_nopea",imgWhyYoupretNopea); 
setImage("img_customer_view",imgCustomerView); 
setImage("img_youpret_job_office",imgYoupretJobOffice); 
setImage("img_faq",imgFaq); 
setImage("img_faq_small",imgFaqSmall);
setImage("img_academy_phones", imgAcademyPhones);
setImage("img_academy_lms", imgAcademyLMS);
setImage("img_academy_phone", imgAcademyPhone);
setImage("img_academy_support", imgAcademySupport);
setImage("img_academy_intra", imgAcademyIntra);
setImage("img_academy_course_tool", imgAcademyCourseTool);
setImage("img_academy_fast", imgAcademyFast);
setImage("img_academy_suit", imgAcademySuit);
setImage("img_academy_hand", imgAcademyHand);
setImage("img_academy_laptop", imgAcademyLaptop);
setImage("img_academy_logo_white", imgAcademyLogoWhite);
setImage("img_academy_logo_blue", imgAcademyLogoBlue);
setImage("img_academy_logo_blue_secondary", imgAcademyLogoBlueSecondary);
setImage("img_academy_screen_1", imgAcademyScreen1);
setImage("img_academy_screen_2", imgAcademyScreen2);
setImage("img_technology_streamline", imgTechnologyStreamline);
setImage("img_technology_uses", imgTechnologyUses);
setImage("img_technology_accessible", imgTechnologyAccessible);
setImage("img_technology_automatic", imgTechnologyAutomatic);
setImage("img_technology_grow", imgTechnologyGrow);
setImage("img_technology_oversee", imgTechnologyOversee);
setImage("img_technology_system", imgTechnologySystem);
setImage("img_technology_network", imgTechnologyNetwork);
setImage("img_youpret_work_environment", imgYoupretWorkEnvironment);
setImage("img_youpret_workplace", imgYoupretWorkplace);
setImage("techInterpretingSystemImage", imgTechnologyNetwork);
setImage("img_news_satisfied_interpreters_1", imgNewsSatisfiedInterpreters1);
setImage("img_news_satisfied_interpreters_2", imgNewsSatisfiedInterpreters2);
setImage("img_news_satisfied_interpreters_3", imgNewsSatisfiedInterpreters3);
setImage("img_news_satisfied_interpreters_4", imgNewsSatisfiedInterpreters4);
setImage("img_news_satisfied_interpreters_5", imgNewsSatisfiedInterpreters5);
setImage("img_news_satisfied_interpreters_6", imgNewsSatisfiedInterpreters6);
setImage("img_news_satisfied_interpreters_1_ru", imgNewsSatisfiedInterpreters1Ru);
setImage("img_news_satisfied_interpreters_2_ru", imgNewsSatisfiedInterpreters2Ru);
setImage("img_news_satisfied_interpreters_3_ru", imgNewsSatisfiedInterpreters3Ru);
setImage("img_news_satisfied_interpreters_4_ru", imgNewsSatisfiedInterpreters4Ru);
setImage("img_news_satisfied_interpreters_5_ru", imgNewsSatisfiedInterpreters5Ru);
setImage("img_news_satisfied_interpreters_6_ru", imgNewsSatisfiedInterpreters6Ru);
setImage("img_news_survey", imgNewsSurvey);
setImage("img_news_survey_small", imgNewsSurveySmall);
setImage("img_news_survey_ru", imgNewsSurveyRu);
setImage("img_news_survey_small_ru", imgNewsSurveySmallRu);
setImage("img_news_kayttoonottokoulutus", imgNewsKayttoonottokoulutus);
setImage("img_news_kayttoonottokoulutus_small", imgNewsKayttoonottokoulutusSmall);
setImage("img_news_nps_number", imgNewsNpsNumber);
setImage("img_news_nps_luku", imgNewsNpsLuku);
setImage("img_news_nps_sv", imgNewsNpsSv);
setImage("img_news_artboard_1", imgNewsArtboard1);
setImage("img_news_artboard_1_secondary", imgNewsArtboard1Secondary);
setImage("img_news_artboard_2", imgNewsArtboard2);
setImage("img_news_artboard_2_secondary", imgNewsArtboard2Secondary);
setImage("img_news_artboard_57", imgNewsArtboard57);
setImage("img_news_artboard_57_secondary", imgNewsArtboard57Secondary);
setImage("img_news_customer_satisfaction_small", imgNewsCustomerSatisfactionSmall);
setImage("img_news_customer_satisfaction", imgNewsCustomerSatisfaction);
setImage("img_news_customer_satisfaction_secondary", imgNewsCustomerSatisfactionSecondary);
setImage("img_news_rekrykoulutus_small", imgNewsRekrykoulutusSmall);
setImage("img_news_rekrykoulutus", imgNewsRekrykoulutus);
setImage("img_news_kuntapaattajat_small", imgNewsKuntapaattajatSmall);
setImage("img_news_kuntapaattajat", imgNewsKuntapaattajat);
setImage("img_kuntapaattajat_terveydenhuolto", imgNewsKuntapaattajatTerveydenhoito);
setImage("img_news_siun_sote_ja_pk_small", imgNewsSiunSoteJaPkSmall);
setImage("img_news_siun_sote_ja_pk", imgNewsSiunSoteJaPk);
setImage("img_mobile_app_promo", imgMobileAppPromo);
setImage("img_news_te_palvelut_small", imgNewsTePalvelutSmall);
setImage("img_news_te_palvelut", imgNewsTePalvelut);
setImage("img_news_varsinais_suomen_te_palvelut_small", imgNewsVarsinaisSuomenTePalvelutSmall);
setImage("img_news_varsinais_suomen_te_palvelut", imgNewsVarsinaisSuomenTePalvelut);
setImage("img_news_uusimaa_te_services", imgNewsUusimaaTeServices);
setImage("img_news_uusimaa_te_services_small", imgNewsUusimaaTeServicesSmall);
setImage("img_news_southwest_finland_te_services", imgNewsSouthwestFinlandTeServices);
setImage("img_news_southwest_finland_te_services_small", imgNewsSouthwestFinlandTeServicesSmall);
setImage("img_news_asiakaspalvelu_asiakkaiden_small", imgNewsAsiakaspalveluAsiakkaidenSmall);
setImage("img_news_asiakaspalvelu_asiakkaiden", imgNewsAsiakaspalveluAsiakkaiden);
setImage("img_news_youpret_deloitte_small", imgNewsYoupretDeloitteSmall);
setImage("img_news_youpret_deloitte", imgNewsYoupretDeloitte);
setImage("img_news_asiakastarinat_kuopio_kotokunta", imgNewsAsiakastarinatKuopioKotokunta);
setImage("img_news_asiakastarinat_kuopio_kotokunta_small", imgNewsAsiakastarinatKuopioKotokuntaSmall);
setImage("img_news_rekrykoulutus_2024",imgNewsRekrykoulutus2024);
setImage("img_news_rekrykoulutus_2024_small",imgNewsRekrykoulutus2024Small);
setImage("img_news_tekoalyn_vastuullinen_kaytto",imgNewsTekoalynVastuullinenKaytto);
setImage("img_news_tekoalyn_vastuullinen_kaytto_small",imgNewsTekoalynVastuullinenKayttoSmall);
setImage("img_news_tekoalyn_vastuullinen_kaytto_eng",imgNewsTekoalynVastuullinenKayttoEng);
setImage("img_news_tekoalyn_vastuullinen_kaytto_small_eng",imgNewsTekoalynVastuullinenKayttoSmallEng);
setImage("img_news_kototekopalkinto_small", imgNewsKototekopalkintoSmall);
setImage("img_news_kototekopalkinto", imgNewsKototekopalkinto);
setImage("img_news_ihminen_vastuussa_tekoalysta", imgNewsIhminenVastuussaTekoalysta);
setImage("img_news_ihminen_vastuussa_tekoalysta_small", imgNewsIhminenVastuussaTekoalystaSmall);
setImage("img_news_ihminen_vastuussa_tekoalysta_eng", imgNewsIhminenVastuussaTekoalystaEng);
setImage("img_news_ihminen_vastuussa_tekoalysta_small_eng", imgNewsIhminenVastuussaTekoalystaSmallEng);
setImage("img_news_hei_kirjoita_minulle_blogi", imgNewsHeiKirjoitaMinulleBlogi);
setImage("img_news_hei_kirjoita_minulle_blogi_small", imgNewsHeiKirjoitaMinulleBlogiSmall);
setImage("img_news_hei_kirjoita_minulle_blogi_eng", imgNewsHeiKirjoitaMinulleBlogiEng);
setImage("img_news_hei_kirjoita_minulle_blogi_small_eng", imgNewsHeiKirjoitaMinulleBlogiSmallEng);
setImage("img_news_kohokohdat", imgNewsKohokohdat);
setImage("img_news_kohokohdat_small", imgNewsKohokohdatSmall);
setImage("img_news_b_corp_part_2", imgNewsBCorpPart2);
setImage("img_news_b_corp_part_2_small", imgNewsBCorpPart2Small);
setImage("img_news_b_corp_part_2_eng", imgNewsBCorpPart2Eng);
setImage("img_news_b_corp_part_2_small_eng", imgNewsBCorpPart2SmallEng);
setImage("img_news_b_corp_part_2_is", imgNewsBCorpPart2Is);
setImage("img_news_b_corp_part_2_small_is", imgNewsBCorpPart2SmallIs);
setImage("img_news_b_corp_part_2_sv", imgNewsBCorpPart2Sv);
setImage("img_news_b_corp_part_2_small_sv", imgNewsBCorpPart2SmallSv);
setImage("img_news_b_corp_part_2_infographic_english_stage_8_eng", imgNewsBCorpPart2InfographicEnglishStage8Eng);
setImage("img_news_b_corp_part_2_infographic_english_stage_8_suomi", imgNewsBCorpPart2InfographicEnglishStage8Suomi);
setImage("img_news_b_corp_part_2_infographic_english_stage_8_sv", imgNewsBCorpPart2InfographicEnglishStage8Sv);
setImage("img_news_b_corp_part_2_infographic_english_stage_8_is", imgNewsBCorpPart2InfographicEnglishStage8Is);
setImage("img_news_tulkin_tyo_2020_luvulla", imgNewsTulkinTyo2020Luvulla);
setImage("img_news_tulkin_tyo_2020_luvulla_small", imgNewsTulkinTyo2020LuvullaSmall);
setImage("img_news_tulkin_tyo_2020_luvulla_eng", imgNewsTulkinTyo2020LuvullaEng);
setImage("img_news_tulkin_tyo_2020_luvulla_small_eng", imgNewsTulkinTyo2020LuvullaSmallEng);
setImage("img_news_all_about_sustainability_eng", imgNewsAllAboutSustainabilityEng);
setImage("img_news_all_about_sustainability_eng_small", imgNewsAllAboutSustainabilityEngSmall);
setImage("img_news_all_about_sustainability_is", imgNewsAllAboutSustainabilityIs);
setImage("img_news_all_about_sustainability_is_small", imgNewsAllAboutSustainabilityIsSmall);
setImage("img_news_all_about_sustainability_our_operations_eng", imgNewsAllAboutSustainabilityOurOperationsEng);
setImage("img_news_toimintamme", imgNewsToimintamme);
setImage("img_news_kaikki_vastuullisuus_raportoinnista", imgNewsKaikkiVastuullisuusRaportoinnista);
setImage("img_news_kaikki_vastuullisuus_raportoinnista_small", imgNewsKaikkiVastuullisuusRaportoinnistaSmall);
setImage("img_news_press_release_small", imgNewsPressReleaseSmall);
setImage("img_news_press_release", imgNewsPressRelease);
setImage("img_news_press_release_small_eng", imgNewsPressReleaseSmallEng);
setImage("img_news_press_release_eng", imgNewsPressReleaseEng);
setImage("img_news_aasian_kielet", imgNewsAasianKielet);
setImage("img_news_aasian_kielet_small", imgNewsAasianKieletSmall);
setImage("img_news_aasian_kartta", imgNewsAasianKartta);
setImage("img_news_aasian_kartta_modal", imgNewsAasianKarttaModal);
setImage("img_news_5_hyvaa_syyta", imgNews5hyvaaSyyta);
setImage("img_news_5_hyvaa_syyta_small", imgNews5hyvaaSyytaSmall);
setImage("img_news_5_hyvaa_syyta_korkea_asiakastyytyväisyys", imgNews5hyvaaSyytaKorkeaAsiakastyytyvaisyys);
setImage("img_news_5_hyvaa_syyta_vastuullinen_tulkkauspalvelu", imgNews5hyvaaSyytaVastuullinenTulkkauspalvelu);
setImage("img_news_5_hyvaa_syyta_upeat_youpret_tulkit", imgNews5hyvaaSyytaUpeatYoupretTulkit);
setImage("img_news_5_hyvaa_syyta_edistynyt_teknologia", imgNews5hyvaaSyytaEdistynytTeknologia);
setImage("img_news_5_hyvaa_syyta_erinomainen_tulkkien_saatavuus", imgNews5hyvaaSyytaErinomainenTulkkienSaatavuus);
setImage("img_news_5_good_reasons", imgNews5goodReasons);
setImage("img_news_5_good_reasons_small", imgNews5goodReasonsSmall);
setImage("img_news_5_good_reasons_is", imgNews5goodReasonsIs);
setImage("img_news_5_good_reasons_small_is", imgNews5goodReasonsSmallIs);
setImage("img_news_5_good_reasons_responsible_interpretation_services", imgNews5goodReasonsResponsibleInterpretationServices);
setImage("img_news_5_good_reasons_customer_satisfaction", imgNews5goodReasonsCustomerSatisfaction);
setImage("img_news_5_good_reasons_fantastic_youpret_interpreters", imgNews5goodReasonsFantasticYoupretInterpreters);
setImage("img_news_5_good_reasons_100_availability", imgNews5goodReasons100availability);
setImage("img_news_5_good_reasons_advanced_technology", imgNews5goodReasonsAdvancedTechnology);
setImage("img_news_5_hyvaa_syyta_sv", imgNews5hyvaaSyytaSv);
setImage("img_news_5_hyvaa_syyta_small_sv", imgNews5hyvaaSyytaSmallSv);
setImage("img_news_5_sv_100", imgNews5sv100);
setImage("img_news_5_sv_77", imgNews5sv77);
setImage("img_news_5_sv_88", imgNews5sv88);
setImage("img_news_5_sv_68", imgNews5sv68);
setImage("img_news_5_sv_89", imgNews5sv89);
setImage("img_news_youpret_heats_small", imgNewsYoupretHeatsSmall);
setImage("img_news_youpret_heats", imgNewsYoupretHeats);
setImage("img_news_youpret_heats_small_eng", imgNewsYoupretHeatsSmallEng);
setImage("img_news_youpret_heats_eng", imgNewsYoupretHeatsEng);
setImage("img_news_youpret_heats_small_ru", imgNewsYoupretHeatsSmallRu);
setImage("img_news_youpret_heats_ru", imgNewsYoupretHeatsRu);
setImage("img_news_youpret_heats_small_sv", imgNewsYoupretHeatsSmallSv);
setImage("img_news_youpret_heats_sv", imgNewsYoupretHeatsSv);
setImage("img_news_our_NPS_is_77", imgNewsOurNPSis77);
setImage("img_news_importance_of_sustainability", imgNewsImportanceOfSustainability);
setImage("img_news_satisfaction_with_application", imgNewsSatisfactionWithApplication);
setImage("img_news_satisfaction_with_handling_orders", imgNewsSatisfactionWithHandlingOrders);
setImage("img_news_satisfaction_with_interperer_availability", imgNewsSatisfactionWithInterpererAvailability);
setImage("img_news_satisfaction_with_quality", imgNewsSatisfactionWithQuality);
setImage("img_news_satisfaction_with_sustainability", imgNewsSatisfactionWithSustainability);
setImage("img_news_NPS_luku_68", imgNewsNPSluku68);
setImage("img_news_asiakkat_pitaavaat_vastuullisuutta", imgNewsAsiakkatPitaavaatVastuullisuutta);
setImage("img_news_tyytyvaaisyys_asiakaspalvelu", imgNewsTyytyvaaisyysAsiakaspalvelu);
setImage("img_news_tyytyvaaisyys_sovellukseen", imgNewsTyytyvaaisyysSovellukseen);
setImage("img_news_tyytyvaaisyys_tulkkausten_laatuun", imgNewsTyytyvaaisyysTulkkaustenLaatuun);
setImage("img_news_tyytyvaaisyys_tulkkien_saatavuuteen", imgNewsTyytyvaaisyysTulkkienSaatavuuteen);
setImage("img_news_our_NPS_is_68_ru", imgNewsOurNPSis68Ru);
setImage("img_news_application_ru_1", imgNewsApplicationRu1);
setImage("img_news_quality_ru_2", imgNewsQualityRu2);
setImage("img_news_availability_ru_3", imgNewsAvailabilityRu3);
setImage("img_news_orders_ru_4", imgNewsOrdersRu4);
setImage("img_news_importance_ru_5", imgNewsImportanceRu5);
setImage("img_news_our_NPS_is_77_sv", imgNewsOurNPSis77Sv);
setImage("img_news_nojdhet_app_sv1", imgNewsNojdhetAppSv1);
setImage("img_news_nojdhet_kvalitet_sv_2", imgNewsNojdhetKvalitetSv2);
setImage("img_news_nojdhet_tolktillganglig_sv_3", imgNewsNojdhetTolktillgangligSv3);
setImage("img_news_nojdhet_kundtjanstens_sv_4", imgNewsNojdhetKundtjanstensSv4);
setImage("img_news_kunder_sv_5", imgNewsKunderSv5);
setImage("img_news_youpret_translate_small", imgNewsYoupretTranslateSmall);
setImage("img_news_youpret_translate", imgNewsYoupretTranslate);
setImage("img_news_youpret_translate_small_eng", imgNewsYoupretTranslateSmallEng);
setImage("img_news_youpret_translate_eng", imgNewsYoupretTranslateEng);
setImage("img_news_katu", imgNewsKatu);
setImage("img_news_katu_small", imgNewsKatuSmall);
setImage("img_news_yko", imgNewsYKO);
setImage("img_news_yko_small", imgNewsYKOSmall);
setImage("img_news_yko_artboard", imgNewsYKOArtboard);

setImage("kayttoohjeKuva", kayttoohjeKuva);
setImage("img_etatulkkausKuva", imgEtatulkkausKuva);
setImage("img_etatulkkausKuvaSv", imgEtatulkkausKuvaSv);
setImage("img_ajanvarausKuva", imgAjanvarausKuva);
setImage("img_ajanvarausKuvaSv", imgAjanvarausKuvaSv);
setImage("img_soitaKuva", imgSoitaKuva);
setImage("img_soitaKuvaSv", imgSoitaKuvaSv);
setImage("img_loppuKuva", imgLoppuKuva);
setImage("img_loppuKuvaSv", imgLoppuKuvaSv);
setImage("img_menuKuva", imgMenuKuva);
setImage("img_menuKuvaSv", imgMenuKuvaSv);
setImage("img_viiteKuva", imgViiteKuva);
setImage("img_viiteKuvaSv", imgViiteKuvaSv);
setImage("img_lataaSovellus", imgLataaSovellus);
setImage("img_lataaSovellusSv", imgLataaSovellusSv);
setImage("nuoliYlos", nuoliYlos);

setImage("img_logo_espoo", imgLogoEspoo);
setImage("img_logo_horizontal", imgLogoHorizontal);
setImage("img_logo_hyria", imgLogoHyria);
setImage("img_logo_joensuu", imgLogoJoensuu);
setImage("img_logo_joensuu_1", imgLogoJoensuu1);
setImage("img_logo_keski_uudenmaa_hyvinvointialue", imgLogoKeskiUudenmaaHyvinvointialue);
setImage("img_logo_keski_uudenmaa_hyvinvointialue_1", imgLogoKeskiUudenmaaHyvinvointialue1);
setImage("img_logo_mehilainen", imgLogoMehilainen);
setImage("img_logo_pihla_group", imgLogoPihlaGroup);
setImage("img_logo_porokylan_leipomo", imgLogoPorokylanLeipomo);
setImage("img_logo_siun_sote", imgLogoSiunSote);
setImage("img_logo_te_toimisto", imgLogoTeToimisto);
setImage("img_logo_te_toimisto_1", imgLogoTeToimisto1);
setImage("img_logo_thl", imgLogoThl);
setImage("img_logo_thl_1", imgLogoThl1);
setImage("img_logo_tuisku", imgLogoTuisku);
setImage("img_logo_suomen_yrittajat", imgLogoSuomenYrittajat);
setImage("img_logo_layer", imgLogoLayer);
setImage("img_logo_sky_round", imgLogoSkyRound);
setImage("img_logo_punainen_risti", imgLogoPunainenRisti);
setImage("img_logo_tivi", imgLogoTivi);
setImage("img_logo_kauppalehti", imgLogoKauppalehti);
setImage("img_logo_heili", imgLogoHeili);
setImage("img_logo_karjalainen", imgLogoKarjalainen);
setImage("img_logo_b_corp_tagline", imgLogoBCorpTagline);
setImage("img_logo_b_corp_tagline_mobile", imgLogoBCorpTaglineMobile);
setImage("img_logo_kestavan_kehityksen_tavoitteet", imgLogoKestavanKehityksenTavoitteet);
setImage("img_logo_sustainability_goals_eng", imgLogoSustainabilityGoalsEng);
setImage("img_logo_kauppakamari", imgLogoKauppakamari);
setImage("img_logo_kauppakamari_mobile", imgLogoKauppakamariMobile);
setImage("img_logo_globala_malen_horizontell_sv", imgLogoGlobalaMalenHorizontellSv);

setImage("img_logo_espoo_mobile", imgLogoEspooMobile);
setImage("img_logo_horizontal_mobile", imgLogoHorizontalMobile);
setImage("img_logo_hyria_mobile", imgLogoHyriaMobile);
setImage("img_logo_joensuu_mobile", imgLogoJoensuuMobile);
setImage("img_logo_keski_uudenmaa_hyvinvointialue_mobile", imgLogoKeskiUudenmaaHyvinvointialueMobile);
setImage("img_logo_mehilainen_mobile", imgLogoMehilainenMobile);
setImage("img_logo_pihla_group_mobile", imgLogoPihlaGroupMobile);
setImage("img_logo_porokylan_leipomo_mobile", imgLogoPorokylanLeipomo);
setImage("img_logo_siun_sote_mobile", imgLogoSiunSoteMobile);
setImage("img_logo_te_toimisto_mobile", imgLogoTeToimistoMobile);
setImage("img_logo_thl_mobile", imgLogoThlMobile);
setImage("img_logo_tuisku_mobile", imgLogoTuiskuMobile);
setImage("img_logo_suomen_yrittajat_mobile", imgLogoSuomenYrittajatMobile);
setImage("img_logo_layer_mobile", imgLogoLayerMobile);
setImage("img_logo_sky_round_mobile", imgLogoSkyRoundMobile);
setImage("img_logo_punainen_risti_mobile", imgLogoPunainenRistiMobile);
setImage("img_logo_ekhva", imgLogoEkhva);
setImage("img_logo_ekhva_mobile", imgLogoEkhvaMobile);
setImage("img_logo_ekhva_1", imgLogoEkhva1);
setImage("img_logo_ekhva_1_mobile", imgLogoEkhva1Mobile);
setImage("img_logo_lappeenranta", imgLogoLappeenranta);
setImage("img_logo_lappeenranta_mobile", imgLogoLappeenrantaMobile);
setImage("img_logo_hameenlinnan_kaupunki", imgLogoHameenlinnanKaupunki);
setImage("img_logo_hameenlinnan_kaupunki_mobile", imgLogoHameenlinnanKaupunkiMobile);
setImage("img_logo_youpret_streamlined", imgLogoYoupretStreamlined);
setImage("img_logo_youpret_streamlined_mobile", imgLogoYoupretStreamlinedMobile);
setImage("img_logo_kotokunta", imgLogoKotokunta);
setImage("img_logo_kotokunta_mobile", imgLogoKotokuntaMobile);
setImage("img_logo_kela",imgLogoKela);
setImage("img_logo_kela_mobile",imgLogoKelaMobile);
setImage("img_logo_pilke", imgLogoPilke);
setImage("img_logo_pilke_mobile", imgLogoPilkeMobile);
setImage("img_logo_migri", imgLogoMigri);
setImage("img_logo_migri_mobile", imgLogoMigriMobile);

setImage("img_logo_kotokunta", imgLogoKotokunta);
setImage("img_logo_kotokunta_mobile", imgLogoKotokuntaMobile);
setImage("img_logo_tyohame", imgLogoTyohame);
setImage("img_logo_tyohame_mobile", imgLogoTyohameMobile);
setImage("img_logo_kela", imgLogoKela);
setImage("img_logo_kela_mobile", imgLogoKelaMobile);





setImage("img_news_jarkko_karjalainen_youpret", imgNewsJarkkoKarjalainenYoupret);
setImage("img_news_asser_kakko_youpret_1", imgNewsAsserKakkoYoupret1);

setImage("img_news_satu_pirhonen_youpret_circle", imgNewsSatuPirhonenYoupretCircle);

setImage("img_services",imgServices);
setImage("img_schools",imgSchools);
setImage("img_youpret_visma_video",imgYoupretVismaVideo);
setImage("img_uudet_nettisivut_2020",imgUudetNettisivut2020);
setImage("img_uudet_nettisivut_2020_kirjaudu",imgUudetNettisivut2020Kirjaudu);
setImage("img_news_toissa_youpretilla", imgNewsYoupretLahjoittaa);
setImage("img_news_toissa_youpretilla_small", imgNewsYoupretLahjoittaaSmall);
setImage("img_news_toissa_banner_maya", imgNewsToissaYoupretillaBanner);
setImage("img_news_toissa_banner_maya_small", imgNewsToissaYoupretillaBannerSmall);
setImage("img_news_toissa_banner_nea", imgNewsToissaYoupretillaBanner);
setImage("img_news_toissa_banner_nea_small", imgNewsToissaYoupretillaBannerSmall);
setImage("img_news_toissa_banner_laura", imgNewsToissaYoupretillaBanner);
setImage("img_news_toissa_banner_laura_small", imgNewsToissaYoupretillaBannerSmall);
setImage("img_news_toissa_maya", imgNewsMaya);
setImage("img_news_toissa_nea", imgNewsNea);
setImage("img_news_toissa_laura", imgNewsLaura);
setImage("img_news_yritysvastuu_title", imgRecruitment);
setImage("img_news_yritysvastuu_title_small", imgRecruitmentSmall);
setImage("img_news_yritysvastuu", imgYritysVastuu);
setImage("img_news_yritysvastuu_small", imgYritysVastuu_small);
setImage("img_open_jobs", imgAvoimetTyopaikat);
setImage("img_driving_school_banner", drivingSchoolBanner);
setImage("img_driving_school_banner_small", drivingSchoolBannerSmall);
setImage("img_driving_school_banner_2", drivingSchoolBanner2);
setImage("img_legal_logo_banner", legalBanner);
setImage("img_legal_banner_2", legalBanner2);
setImage("img_legal_news_banner", legalNewsBanner);
setImage("img_legal_news_banner_small", legalNewsBannerSmall);
setImage("img_news_job_assistant_banner", imgNewsJobAssistant);
setImage("img_news_job_assistant_banner_small", imgNewsJobAssistantSmall);
setImage("img_news_drivingshcool_banner", imgNewsDrivingSchoolBanner);
setImage("img_news_drivingshcool_banner_small", imgNewsDrivingSchoolBannerSmall);
setImage("img_childhood_education_banner", imgChildhoodEducationBanner);
setImage("img_childhood_education_banner_small", imgChildhoodEducationBannerSmall);
setImage("img_childhood_education_banner_2", imgChildhoodEducationBanner2);
setImage("img_childhood_education_banner_2_small", imgChildhoodEducationBanner2Small);
setImage("img_news_kindergarten_banner", imgNewsKindergarten);
setImage("img_news_kindergarten_banner_small", imgNewsKindergartenSmall);
setImage("img_news_alustatalous_banner", imgNewsAlustatalousBanner);
setImage("img_news_alustatalous_banner_small", imgNewsAlustatalousBannerSmall);
setImage("img_health_interpreter_banner", imgHealthInterpreterBanner);
setImage("img_health_interpreter_banner_small", imgHealthInterpreterBannerSmall);
setImage("img_health_interpreter2_banner", imgHealthInterpreter2Banner);
setImage("img_health_interpreter2_banner_small", imgHealthInterpreter2BannerSmall);
setImage("img_news_miro_teravainen_banner", imgNewsMiroTeravainenBanner);
setImage("img_news_miro_teravainen_banner_small", imgNewsMiroTeravainenBannerSmall);
setImage("img_news_miro_teravainen", imgNewsMiroTeravainen);
setImage("img_news_dawda_banner", imgNewsDawdaBanner);
setImage("img_news_dawda_banner_small", imgNewsDawdaBannerSmall);
setImage("img_news_dawda_image_1", imgNewsDawdaImage1);
setImage("img_news_dawda_image_2", imgNewsDawdaImage2);
setImage("img_news_dawda_image_3", imgNewsDawdaImage3);
setImage("img_news_job_sales_assistant_banner", imgNewsJobSalesAssistant);
setImage("img_news_job_sales_assistant_banner_small", imgNewsJobSalesAssistantSmall);
setImage("img_news_customer_servant_banner", imgNewsJobCustomerServant);
setImage("img_news_customer_servant_banner_small", imgNewsJobCustomerServantSmall);
setImage("img_news_customer_advisor_banner", imgNewsJobCustomerAdvisor);
setImage("img_news_customer_advisor_banner_small", imgNewsJobCustomerAdvisorSmall);
setImage("img_news_rekrykoulutus_banner", imgNewsRecruitmentTraining);
setImage("img_news_rekrykoulutus_banner_small", imgNewsRecruitmentTrainingSmall);
setImage("img_news_youpretin_uusi_mobiilisovellus", imgNewsNewApp);
setImage("img_news_youpretin_uusi_mobiilisovellus_small", imgNewsNewAppSmall);
setImage("img_news_sarastia_youpret_small", imgNewsSarastiaYoupretSmall);
setImage("img_news_sarastia_youpret", imgNewsSarastiaYoupret);
setImage("img_news_tips", imgNewsTips);
setImage("img_news_tips_small", imgNewsTipsSmall);
setImage("img_news_taisto", imgNewsTaisto);
setImage("img_news_taisto_small", imgNewsTaistoSmall);
setImage("img_news_vuosi_2023", imgNewsVuosi2023);
setImage("img_news_vuosi_2023_small", imgNewsVuosi2023Small);
setImage("img_news_infographic", imgNewsInfographicEn);
setImage("img_news_infograafi", imgNewsInfograafi);
setImage("img_news_infograafi_ru", imgNewsInfograafiRu);
setImage("img_news_collage", imgNewsCollage);
setImage("img_news_youpret_b_corp_small", imgNewsYoupretBCorpSmall);
setImage("img_news_youpret_b_corp", imgNewsYoupretBCorp);
setImage("img_news_youpret_b_corp_en", imgNewsYoupretBCorp);
setImage("img_news_youpret_workenvironment", imgNewsYoupretWorkenvironment); 
setImage("img_news_plant", imgNewsPlant);
setImage("img_news_lecture", imgNewsLecture);
setImage("img_news_enhancing_interpretation_quality", imgNewsEnhancingInterpretationQuality);
setImage("img_news_enhancing_interpretation_quality_small", imgNewsEnhancingInterpretationQualitySmall);
setImage("img_news_enhancing_interpretation_translator", imgNewsEnhancingInterpretationTranslator);
setImage("img_news_enhancing_interpretation_essay", imgNewsEnhancingInterpretationEssay);
setImage("img_news_enhancing_interpretation_mobile", imgNewsEnhancingInterpretationMobile);
setImage("img_news_enhancing_interpretation_video_conference", imgNewsEnhancingInterpretationVideoConference);
setImage("img_news_nain_yritykset_rakentavat_luottamusta", imgNewsNainYrityksetRakentavatLuottamusta);
setImage("img_news_nain_yritykset_rakentavat_luottamusta_small", imgNewsNainYrityksetRakentavatLuottamustaSmall);
setImage("img_news_tulkkausolosuhteiden_vaikutus_tulkkauksen_onnistumiseen", imgNewsTulkkausolosuhteidenVaikutusTulkkauksenOnnistumiseen);
setImage("img_news_tulkkausolosuhteiden_vaikutus_tulkkauksen_onnistumiseen_small", imgNewsTulkkausolosuhteidenVaikutusTulkkauksenOnnistumiseenSmall);
setImage("img_news_academy_kehittaa_tulkkaustaitoja", imgNewsAcademyKehittaaTulkkaustaitoja);
setImage("img_news_academy_kehittaa_tulkkaustaitoja_small", imgNewsAcademyKehittaaTulkkaustaitojaSmall);
setImage("img_news_palaute_parantaa", imgNewsPalauteParantaa);
setImage("img_news_palaute_parantaa_small", imgNewsPalauteParantaaSmall);
setImage("img_news_syksyn_tapahtumat_small", imgNewsSyksynTapahtumatSmall);
setImage("img_news_syksyn_tapahtumat", imgNewsSyksynTapahtumat);
setImage("img_news_tiedote_postaus_kela_small", imgNewsTiedotePostausKelaSmall);
setImage("img_news_tiedote_postaus_kela", imgNewsTiedotePostausKela);
setImage("img_news_nurse_days", imgNewsNurseDays);
setImage("img_news_nurse_days_small", imgNewsNurseDaysSmall);
setImage("img_news_nurse_days_sv", imgNewsNurseDaysSv);
setImage("img_news_nurse_days_sv_small", imgNewsNurseDaysSvSmall);
setImage("img_news_kuinka_valita_small", imgNewsKuinkaValitaSmall);
setImage("img_news_kuinka_valita", imgNewsKuinkaValita);
setImage("img_news_interpreters_satisfaction_survey", imgNewsInterpretersSatisfactionSurvey);
setImage("img_news_interpreters_satisfaction_survey_fi", imgNewsInterpretersSatisfactionSurveyFi);
setImage("img_news_interpreters_satisfaction_survey_small", imgNewsInterpretersSatisfactionSurveySmall);
setImage("img_news_interpreters_satisfaction_survey_small_fi", imgNewsInterpretersSatisfactionSurveySmallFi);
setImage("img_news_interpreters_satisfaction_survey_small_is", imgNewsInterpretersSatisfactionSurveySmallIs);
setImage("img_news_interpreters_satisfaction_survey_is", imgNewsInterpretersSatisfactionSurveyIs);
setImage("img_news_interpreters_satisfaction_survey_podcast", imgNewsInterpretersSatisfactionSurveyPodcast);
setImage("img_news_interpreters_satisfaction_survey_podcast_fi", imgNewsInterpretersSatisfactionSurveyPodcastFi);
setImage("img_news_interpreters_satisfaction_survey_NPS", imgNewsInterpretersSatisfactionSurveyNPS);
setImage("img_news_interpreters_satisfaction_survey_NPS_eng", imgNewsInterpretersSatisfactionSurveyNPSEng);
setImage("img_news_vastaanottokeskus_keski_suomi_small", imgNewsVastaanottokeskusKeskiSuomiSmall);
setImage("img_news_vastaanottokeskus_keski_suomi", imgNewsVastaanottokeskusKeskiSuomi);
setImage("img_news_tulkkauspalveluiden_hyodyntaminen", imgNewsTulkkauspalveluidenHyodyntaminen);
setImage("img_news_tulkkauspalveluiden_hyodyntaminen_small", imgNewsTulkkauspalveluidenHyodyntaminenSmall);
setImage("img_news_youpretilta_ratkaisut", imgNewsYoupretiltaRatkaisut);
setImage("img_news_youpretilta_ratkaisut_small", imgNewsYoupretiltaRatkaisutSmall);
setImage("img_news_kuntamarkkinat", imgNewsKuntamarkkinat);
setImage("img_news_kuntamarkkinat_small", imgNewsKuntamarkkinatSmall);
setImage("img_news_reception_center_eng", imgNewsReceptionCenterEng);
setImage("img_news_reception_center_eng_small", imgNewsReceptionCenterEngSmall);
setImage("img_orientation_1", imgOrientation1);
setImage("img_orientation_2", imgOrientation2);
setImage("img_orientation_3", imgOrientation3);
setImage("img_orientation_4", imgOrientation4);
setImage("img_orientation_5", imgOrientation5);
setImage("img_orientation_1_mobile", imgOrientation1Mobile);
setImage("img_orientation_2_mobile", imgOrientation2Mobile);
setImage("img_orientation_3_mobile", imgOrientation3Mobile);
setImage("img_orientation_4_mobile", imgOrientation4Mobile);
setImage("img_orientation_5_mobile", imgOrientation5Mobile);
setImage("img_orientation_service", imgOrientationService);
setImage("img_cleaning_main", imgCleaningMain);



setImage("svg_arrow_up", svgArrowUp);
setImage("svg_arrow_up_1", svgArrowUp1);

setImage("img_vipuvoimaa_eusta", imgVipuvoimaaEusta);
setImage("img_vipuvoimaa_eusta_2", imgVipuvoimaaEusta2);
setImage("img_vipuvoimaa_eusta_footer", imgVipuvoimaaEusta);
setImage("img_vipuvoimaa_eusta_2_footer", imgVipuvoimaaEusta2);
setImage("img_software_page_banner", softwarePageBanner);
setImage("img_software_page_content", softwarePageContentImage);
setImage("img_software_page_phone", softwarePagePhone);
setImage("img_special_interpreter_childhoodeducation", imgSpecialInterpreterChildhoodEducation);
setImage("img_special_interpreter_drivingschool", imgSpecialInterpreterDrivingSchool);
setImage("img_special_interpreter_health", imgSpecialInterpreterHealth);
setImage("img_special_interpreter_legal", imgSpecialInterpreterLegal);
setImage("img_special_interpreter_business", imgSpecialInterpreterBusiness);
setImage("img_special_interpreter_childhoodeducation_de", imgSpecialInterpreterChildhoodEducationDe);
setImage("img_special_interpreter_drivingschool_de", imgSpecialInterpreterDrivingSchoolDe);
setImage("img_special_interpreter_health_de", imgSpecialInterpreterHealthDe);
setImage("img_special_interpreter_legal_de", imgSpecialInterpreterLegalDe);
setImage("img_special_interpreter_business_de", imgSpecialInterpreterBusinessDe);
setImage("img_special_interpreter_childhoodeducation_ru", imgSpecialInterpreterChildhoodEducationRu);
setImage("img_special_interpreter_drivingschool_ru", imgSpecialInterpreterDrivingSchoolRu);
setImage("img_special_interpreter_health_ru", imgSpecialInterpreterHealthRu);
setImage("img_special_interpreter_legal_ru", imgSpecialInterpreterLegalRu);
setImage("img_special_interpreter_business_ru", imgSpecialInterpreterBusinessRu);
setImage("img_business_interpreter_banner", imgBusinessInterpreterBanner);
setImage("img_business_interpreter_banner_small", imgBusinessInterpreterBannerSmall);
setImage("img_business_interpreter_banner_2", imgBusinessInterpreterBanner2);
setImage("img_business_interpreter_banner_2_small", imgBusinessInterpreterBanner2Small);
setImage("img_business_interpreter_hands_banner", imgBusinessInterpreterHandsBanner);
setImage("img_business_interpreter_hands_banner_small", imgBusinessInterpreterHandsBannerSmall);
setImage("img_news_business_interpreter_banner", imgBusinessInterpreterBanner);
setImage("img_news_business_interpreter_banner_small", imgBusinessInterpreterBannerSmall);
setImage("img_news_rekrykoulutus_kieliteknologia", imgRekrykoulutusKieliteknologia);
setImage("img_news_rekrykoulutus_kieliteknologia_small", imgRekrykoulutusKieliteknologiaSmall);
setImage("img_news_rekrykoulutus", imgNewsRekrykoulutus);
setImage("img_news_rekrykoulutus_small", imgNewsRekrykoulutusSmall);
setImage("img_news_year_2023_kielet", imgNewsYear2023kielet);
setImage("img_news_year_2023_tiistai", imgNewsYear2023tiistain);
setImage("img_news_year_2023_lyhyin", imgNewsYear2023lyhyin);
setImage("img_news_year_2023_tyytyvaisyys", imgNewsYear2023tyytyvaisyys);
setImage("img_news_year_2023_yli", imgNewsYear2023yli);
setImage("img_news_year_2023_kielet_mobile", imgNewsYear2023kielet);
setImage("img_news_year_2023_tiistai_mobile", imgNewsYear2023tiistain);
setImage("img_news_year_2023_lyhyin_mobile", imgNewsYear2023lyhyin);
setImage("img_news_year_2023_tyytyvaisyys_mobile", imgNewsYear2023tyytyvaisyys);
setImage("img_news_year_2023_yli_mobile", imgNewsYear2023yli);
setImage("img_news_youpret_suomen_yrittajien_kumppaniksi_small", imgNewsYoupretSuomenYrittajienKumppaniksiSmall);
setImage("img_news_youpret_suomen_yrittajien_kumppaniksi", imgNewsYoupretSuomenYrittajienKumppaniksi);
setImage("img_news_uusi_academy_kurssi_small", imgNewsUusiAcademyKurssiSmall);
setImage("img_news_uusi_academy_kurssi", imgNewsUusiAcademyKurssi);
setImage("img_news_work_wellbeing_blogpost_small", imgNewsWorkWellbeingBlogpostSmall);
setImage("img_news_work_wellbeing_blogpost", imgNewsWorkWellbeingBlogpost);
setImage("img_news_work_wellbeing_coffee", imgNewsWorkWellbeingCoffee);
setImage("img_news_work_wellbeing_coffee_2", imgNewsWorkWellbeingCoffee2);
setImage("img_news_work_wellbeing_exercices", imgNewsWorkWellbeingExercices);
setImage("img_news_work_wellbeing_exercices_2", imgNewsWorkWellbeingExercices2);
setImage("img_news_work_wellbeing_talk", imgNewsWorkWellbeingTalk);
setImage("img_news_work_wellbeing_talk_2", imgNewsWorkWellbeingTalk2);
setImage("img_academy_course_1", imgAcademyCourse1);
setImage("img_academy_course_2", imgAcademyCourse2);
setImage("img_academy_course_3", imgAcademyCourse3);
setImage("img_academy_course_mental", imgAcademyCourseMental);
setImage("img_academy_course_social", imgAcademyCourseSocial);
setImage("img_open_jobs_man_front", imgOpenJobsManFront);
setImage("img_youpret_job_office_mobile", imgYoupretJobOfficeMobile);
setImage("img_open_jobs_man_back", imgOpenJobsManBack);
setImage("img_youpret_woman_working", imgYoupretWomanWorking);
setImage("img_youpret_coffee_break_1", imgYoupretCoffeeBreak1);
setImage("img_youpret_woman_headphones", imgYoupretWomanHeadphones);
setImage("img_youpret_woman_smiling", imgYoupretWomanSmiling);
setImage("img_responsibility_book_open", imgResponsibilityOpenBook);
setImage("img_nea_kolmonen_youpret", imgNeaKolmonenYoupret);
setImage("img_nea_kolmonen_youpret_1", imgNeaKolmonenYoupret1);
setImage("img_streamlined_mobile_app_promo", imgStreamlinedMobileAppPromo);
setImage("img_streamlined_typing_keyboard", imgStreamlinedTypingKeyboard);
setImage("img_streamlined_typing_keyboard_mobile", imgStreamlinedTypingKeyboardMobile);
setImage("img_streamlined_management_customer_friendly", imgStreamlinedManagementCustomerFriendly);
setImage("img_streamlined_management_customer_friendly_mobile", imgStreamlinedManagementCustomerFriendlyMobile);
setImage("img_streamlined_management_white_labeling", imgStreamlinedManagementWhiteLabeling);
setImage("img_streamlined_management_white_labeling_mobile", imgStreamlinedManagementWhiteLabelingMobile);
setImage("img_streamlined_management_clear_overview", imgStreamlinedManagementClearOverview);
setImage("img_streamlined_management_clear_overview_mobile", imgStreamlinedManagementClearOverviewMobile);
setImage("img_streamlined_management_proven_solution", imgStreamlinedManagementProvenSolution);
setImage("img_streamlined_management_proven_solution_mobile", imgStreamlinedManagementProvenSolutionMobile);
setImage("img_streamlined_management_automated_system", imgStreamlinedManagementAutomatedSystem);
setImage("img_streamlined_management_automated_system_mobile", imgStreamlinedManagementAutomatedSystemMobile);
setImage("img_streamlined_management_company_platform", imgStreamlinedManagementCompanyPlatform);
setImage("img_streamlined_management_company_platform_mobile", imgStreamlinedManagementCompanyPlatformMobile);
setImage("img_harness_language_technology_background", imgHarnessLanguageTechnologyBackground);
setImage("img_harness_language_technology_black", imgHarnessLanguageTechnologyBlack);
setImage("img_harness_language_technology_black_mobile", imgHarnessLanguageTechnologyBlackMobile);
setImage("img_harness_language_technology_abstract_background", imgHarnessLanguageTechnologyAbstractBackground);
setImage("img_harness_language_technology_abstract_background_mobile", imgHarnessLanguageTechnologyAbstractBackgroundMobile);
setImage("img_harness-language-technology-abst-new", imgHarnessLanguageTechnologyAbstNew);
setImage("img_harness_language_technology_abstract_plexus_blue", imgHarnessLanguageTechnologyAbstractPlexusBlue);
setImage("img_harness_language_technology_abstract_plexus_blue_mobile", imgHarnessLanguageTechnologyAbstractPlexusBlueMobile);
setImage("img_customers_guide", imgCustomersGuide);
setImage("img_asiakaspalvelu_harjoittelija_job_offer_banner", imgAsiakaspalveluHarjoittelijaJobOfferBanner);
setImage("img_asiakaspalvelu_job_offer_banner", imgAsiakaspalveluJobOfferBanner);
setImage("img_apply_interpreter", imgApplyInterpreter);
setImage("img_youpret_offers", imgYoupretOffers);
setImage("svg_interpreter_mobile", svgInterpreterMobile);
setImage("svg_interpreter_app", svgInterpreterApp);
setImage("svg_interpreter_silent", svgInterpreterSilent);
setImage("img_youpret_language", imgYoupretLanguage);
setImage("img_youpret_infograph", imgYoupretInfograph);
setImage("img_youpret_infograph_en", imgYoupretInfographEn);
setImage("img_youpret_logo_gallery", imgYoupretLogoGallery);
setImage("img_youpret_image_gallery", imgYoupretImageGallery);
setImage("img_mental_health_ribbon", imgMentalHealthRibbon);
setImage("img_mental_health_useful", imgMentalHealthUseful);
setImage("img_vertti_kypara", imgVerttiKypara);
setImage("img_specialist_mental_health", imgSpecialistMentalHealth);
setImage("img_interpreter_checklist", imgInterpreterChecklist);
setImage("img_interpreter_checklist_infograph", imgInterpreterChecklistInfograph);
setImage("img_customers_stories_bg", imgCustomersStoriesBg);
setImage("img_compensation_bg", imgCompensationBg);
setImage("img_order_translation", imgOrderTranslation);
setImage("img_orientation_key", imgOrientationKey);
setImage("img_orientation_easy", imgOrientationEasy);
setImage("img_translator_apply", imgTranslatorApply);
setImage("img_translator_join", imgTranslatorJoin);
setImage("img_translator_require", imgTranslatorRequire);
setImage("img_translator_why", imgTranslatorWhy);
setImage("img_translator_why_mobile", imgTranslatorWhyMobile);
setImage("img_translator_asser", imgTranslatorAsser);
setImage("img_short_customers", imgShortCustomers);
setImage("img_short_story", imgShortStory);
setImage("img_short_story_mobile", imgShortStoryMobile);
setImage("img_youpret_short_phone", imgShortPhone);
setImage("img_youpret_logo_thanks", imgYoupretLogoThanks);





setImage("img_bcorp_degrees", imgBcorpDegrees);
setImage("img_bcorp_business", imgBcorpBusiness);
setImage("img_bcorp_fair", imgBcorpFair);
setImage("img_bcorp_why", imgBcorpWhy);
setImage("img_bcorp_positive", imgBcorpPositive);
setImage("img_bcorp_positive_en", imgBcorpPositiveEn);
setImage("img_bcorp_positive_sv_1", imgBcorpPositiveSv1);
setImage("img_bcorp_committed", imgBcorpCommitted);
setImage("img_bcorp_report", imgBcorpReport);
setImage("img_bcorp_blog", imgBcorpBlog);
setImage("img_bcorp_handbook", imgBcorpHandbook);
setImage("img_bcorp_report_en", imgBcorpReportEn);
setImage("img_bcorp_blog_en", imgBcorpBlogEn);
setImage("img_bcorp_handbook_en", imgBcorpHandbookEn);
setImage("img_bcorp_report_sv", imgBcorpReportSv);
setImage("img_bcorp_blog_sv", imgBcorpBlogSv);
setImage("img_bcorp_handbook_sv", imgBcorpHandbookSv);
setImage("img_bcorp_customers", imgBcorpCustomers);
setImage("img_bcorp_community", imgBcorpCommunity);
setImage("img_bcorp_people", imgBcorpPeople);
setImage("img_bcorp_covernance", imgBcorpCovernance);
setImage("img_bcorp_environment", imgBcorpEnvironment);
setImage("img_bcorp_declaration", imgBcorpDeclaration);
setImage("img_bcorp_logo", imgBcorpLogo);
setImage("img_bcorp_logo_secondary", imgBcorpLogoSecondary);
setImage("img_bcorp_logo_secondary_mobile", imgBcorpLogoSecondaryMobile);
setImage("img_translation_languages_main", imgTranslationLanguagesMain);
setImage("img_sote_main", imgSoteMain);
setImage("img_language_pages_order", imgLanguagePagesOrder);
setImage("img_language_pages_ai", imgLanguagePagesAi);


setImage("img_sustainability_mask_group", imgSustainabilityMaskGroup);
setImage("img_sustainability_artboard", imgSustainabilityArtboard);
setImage("img_vastuullisuus_raportti_fi", imgVastuullisuusRaporttiFi)

setImage("img_bcorp_second_part_1_fi", imgBcorpSecondPart1fi);
setImage("img_sustainability_certificate_1_fi", imgSustainabilityCertificate1fi);
setImage("img_bcorp_first_part_1_fi", imgBcorpFirstPart1fi);
setImage("img_bcorp_second_part_1_eng", imgBcorpSecondPart1eng);
setImage("img_sustainability_certificate_1_eng", imgSustainabilityCertificate1eng);
setImage("img_bcorp_first_part_1_eng", imgBcorpFirstPart1eng);
setImage("img_sustainability_certificate_1_sv", imgSustainabilityCertificate1sv);
setImage("img_translator_background_keyboard", imgTranslatorBackgroundKeyboard);



//stories images

setImage("img_career_stories", imgCareerStories);
setImage("img_stories_cheerman", imgStoriesCheerman);
setImage("img_stories_cheerman_small", imgStoriesCheermanSmall);
setImage("img_stories_cheeman_tahir", imgStoriesCheemanTahir);
setImage("img_stories_cheeman_tahir_1", imgStoriesCheemanTahir1);
setImage("img_stories_cheeman_tahir_2", imgStoriesCheemanTahir2);
setImage("img_stories_cheeman_tahir_3", imgStoriesCheemanTahir3);
setImage("img_stories_cheeman_tahir_4", imgStoriesCheemanTahir4);
setImage("img_stories_jukka_kylmala_bg", imgStoriesJukkaKylmalaBg);
setImage("img_stories_jukka_kylmala_small", imgStoriesJukkaKylmalaSmall);
setImage("img_stories_jukka_kylmala_1", imgStoriesJukkaKylmala1);
setImage("img_stories_jukka_kylmala_2", imgStoriesJukkaKylmala2);
setImage("img_stories_jukka_kylmala_3", imgStoriesJukkaKylmala3);
setImage("img_stories_jukka_kylmala_4", imgStoriesJukkaKylmala4);
setImage("img_stories_jukka_kylmala_5", imgStoriesJukkaKylmala5);
setImage("img_stories_ali_hokka_bg", imgStoriesAliHokkaBg);
setImage("img_stories_ali_hokka_small", imgStoriesAliHokkaSmall);
setImage("img_stories_ali_hokka_1_stone", imgStoriesAliHokka1stone);
setImage("img_stories_ali_hokka_2_birches", imgStoriesAliHokka2birches);
setImage("img_stories_ali_hokka_3_forest", imgStoriesAliHokka3forest);
setImage("img_stories_ali_hokka_4_phone", imgStoriesAliHokka4phone);
setImage("img_stories_ali_hokka_5_computer", imgStoriesAliHokka5computer);

setImage("img_stories_alja_skotti_bg", imgStoriesAljaSkottiBg);
setImage("img_stories_alja_skotti_small", imgStoriesAljaSkottiSmall);
setImage("img_stories_alja_skotti_1_on_a_break_test", imgStoriesAljaSkotti1onABreakTest);
setImage("img_stories_alja_skotti_2_walking", imgStoriesAljaSkotti2walking);
setImage("img_stories_alja_skotti_3_sitting", imgStoriesAljaSkotti3sitting);
setImage("img_stories_alja_skotti_4_bridge", imgStoriesAljaSkotti4bridge);
setImage("img_stories_alja_skotti_5_riverside", imgStoriesAljaSkotti5riverside);
setImage("img_stories_alja_skotti_6_writing", imgStoriesAljaSkotti6writing);
setImage("img_stories_alja_skotti_7_office", imgStoriesAljaSkotti7office);
setImage("img_stories_alja_skotti_8_smiling_test", imgStoriesAljaSkotti8smilingTest);
setImage("img_stories_alja_skotti_9_working", imgStoriesAljaSkotti9working);


// yhteystiedot
setImage("img_abrial_bertel_youpret",imgAbrialBertelYoupret); 
setImage("img_jani_kamarainen_youpret",imgJaniKamarainenYoupret); 
setImage("img_maya_rytkonen_youpret",imgMayaRytkonenYoupret); 
setImage("img_nea_ruotsalainen_youpret",imgNeaRuotsalainenYoupret); 
setImage("img_laura_kosonen_youpret",imgLauraKosonenYoupret); 
setImage("img_suvi_kingelin_youpret",imgSuviKingelinYoupret); 
setImage("img_heikki_vepsalainen_youpret",imgHeikkiVepsalainenYoupret);
setImage("img_satu_pirhonen_youpret",imgSatuPirhonenYoupret); 
setImage("img_nea_kolmonen_contact_youpret",imgNeaKolmonenContactYoupret); 
setImage("img_tanja_youpret",imgTanjaYoupret); 
setImage("img_heikki_vepsalainen_ceo_youpret", imgHeikkiVepsalainenCeoYoupret);

setImage("img_vilppu_leinonen_youpret", imgNewsVilppuLeinonenYoupret);
setImage("img_news_aida_joderi_youpret", imgNewsAidaJoderiYoupret);
setImage("img_juho_kekkonen_youpret_1", imgJuhoKekkonenYoupret1);
setImage("img_aida_block_author", imgAidaBlockAuthor);
setImage("img_nea_block_author", imgNeaBlockAuthor);
setImage("img_vilppu_block_author", imgVilppuBlockAuthor);

// Metacontent
setContent("meta_content_yp", imgyplogoog)
setContent("img_news_academy_meta", imgNewsAcademyMeta)
setContent("img_news_tulkkien_koulutus_meta", imgNewsTulkkienKoulutusMeta)
setContent("img_news_survey_meta", imgNewsSurveyMeta)
setContent("img_news_palaute_parantaa_meta", imgNewsPalauteParantaaMeta)

// hreffit
setHref("afrikan_kartta_href", imgafrikankarttadownload)


setVideo("mp4_academy_loop", mp4AcademyLoop,)
/**
 * Use to set image src to point file 
 */
function setImage(elementId, imgSrc){
    let img  = document.getElementById(elementId); 
    if(img) img.src=imgSrc;
}
function setVideo(elementId, videoSrc) {
    let video = document.getElementById(elementId);
    if (video) {
        video.src = videoSrc;
    }
}
/** 
 * Use to set content tag to point to an file
 */
function setContent(elementId, imgSrc){
    let img  = document.getElementById(elementId); 
    if(img) img.content=imgSrc;
}

/** 
 * Use to set href tag to point to an file
 */
function setHref(elementId, imgSrc){
    let img  = document.getElementById(elementId); 
    if(img) img.href=imgSrc;
}
